const keyUnit = [
  { key: '18', value: 'Tambor de cincuenta y cinco galones (EUA)' },
  { key: '19', value: 'Camión cisterna' },
  { key: '26', value: 'Tonelada real' },
  { key: '29', value: 'Libra por mil pies cuadrados' },
  { key: '30', value: 'Día de potencia de caballos por tonelada métrica de aire seco' },
  { key: '31', value: 'Pescar' },
  { key: '32', value: 'Kilogramo por tonelada métrica seca del aire' },
  { key: '36', value: 'Pie cúbico por minuto por pie cuadrado' },
  { key: '44', value: 'Bolsa a granel de quinientos kilos' },
  { key: '45', value: 'Bolsa a granel de trescientos kilos' },
  { key: '46', value: 'Bolsa a granel de cincuenta libras' },
  { key: '47', value: 'Bolso de cincuenta libras' },
  { key: '48', value: 'Carga masiva' },
  { key: '53', value: 'Kilogramo teórico' },
  { key: '54', value: 'Tonelada teórica (UK)' },
  { key: '62', value: 'Por ciento por 1000 horas' },
  { key: '63', value: 'Tasa de fracaso en el tiempo' },
  { key: '64', value: 'Libra por pulgada cuadrada, calíbre' },
  { key: '66', value: 'Oersted' },
  { key: '69', value: 'Escala específica de prueba' },
  { key: '71', value: 'Voltios amperios por libra' },
  { key: '72', value: 'Vatio por libra' },
  { key: '73', value: 'Amperios por centímetro' },
  { key: '76', value: 'Gauss' },
  { key: '78', value: 'Kilogauss' },
  { key: '84', value: 'Kilopound-force por pulgada cuadrada' },
  { key: '90', value: 'Saybold segundo universal' },
  { key: '92', value: 'Calorías por centímetro cúbico' },
  { key: '93', value: 'Calorías por gramo' },
  { key: '94', value: 'Unidad de curl' },
  { key: '95', value: 'Veinte mil galones' },
  { key: '96', value: 'Diez mil galones (US)' },
  { key: '97', value: 'Diez kilos de tambor' },
  { key: '98', value: 'Quince kilos de tambor' },
  { key: '05', value: 'Ascensor' },
  { key: '06', value: 'Pequeño aerosol' },
  { key: '08', value: 'Montón de calor' },
  { key: '10', value: 'Grupos' },
  { key: '11', value: 'Equipos' },
  { key: '13', value: 'Raciones' },
  { key: '14', value: 'Shot' },
  { key: '15', value: 'Palo, medida militar.' },
  { key: '16', value: 'Tambor de 115 kilogramos' },
  { key: '17', value: 'Tambor de cien libras' },
  { key: '1A', value: 'Milla de carros' },
  { key: '1B', value: 'Recuento de automóviles' },
  { key: '1C', value: 'Conteo de locomotoras' },
  { key: '1D', value: 'Caboose count' },
  { key: '1E', value: 'Coche vacío' },
  { key: '1F', value: 'Milla de tren' },
  { key: '1G', value: 'Galón del uso del combustible (los EUA)' },
  { key: '1H', value: 'Milla de caboose' },
  { key: '1I', value: ' Tipo de interés fijo' },
  { key: '1J', value: 'Tonelada milla' },
  { key: '1K', value: 'Milla locomotora' },
  { key: '1L', value: 'Recuento total de automóviles' },
  { key: '1M', value: 'Milla total del coche' },
  { key: '1X', value: 'Cuarto de milla' },
  { key: '20', value: ' Contenedores de veinte pies' },
  { key: '21', value: ' Contenedor de cuarenta pies' },
  { key: '22', value: 'Decilitro por gramo' },
  { key: '23', value: 'Gramo por centímetro cúbico' },
  { key: '24', value: 'Libra teórica' },
  { key: '25', value: 'Gramo por centímetro cuadrado' },
  { key: '27', value: 'Tonelada teórica' },
  { key: '28', value: 'Kilogramo por metro cuadrado' },
  { key: '2A', value: 'Radián por segundo' },
  { key: '2B', value: 'Radián por segundo cuadrado' },
  { key: '2C', value: 'Roentgen' },
  { key: '2G', value: 'Voltios CA' },
  { key: '2H', value: 'Voltios CD' },
  { key: '2I', value: 'Unidad térmica británica (tabla internacional) por hora' },
  { key: '2J', value: 'Centímetro cúbico por segundo' },
  { key: '2K', value: 'Pie cúbico por hora' },
  { key: '2L', value: 'Pie cúbico por minuto' },
  { key: '2M', value: 'Centímetro por segundo' },
  { key: '2N', value: 'Decibel' },
  { key: '2P', value: 'Kilobyte' },
  { key: '2Q', value: 'Kilobecquerel' },
  { key: '2R', value: 'Kilocurie' },
  { key: '2U', value: 'Megagramo' },
  { key: '2V', value: 'Megagrama por hora' },
  { key: '2X', value: 'Metro por minuto' },
  { key: '2Y', value: 'Milliroentgen' },
  { key: '2Z', value: 'Milivoltio' },
  { key: '33', value: 'Kilopascal por grtr' },
  { key: '34', value: 'Kilopascal por milimetro' },
  { key: '35', value: 'Milimetro por un segundo centimetro cuadrado' },
  { key: '37', value: 'Onza por pie cuadrado' },
  { key: '38', value: 'Onzas por pie cuadrado por 0,01 pulgadas' },
  { key: '3B', value: 'Megajoule' },
  { key: '3C', value: 'Manmonth' },
  { key: '3E', value: 'Libra por libra de producto' },
  { key: '3G', value: 'Libra por pieza de producto' },
  { key: '3H', value: 'Kilogramo por kilogramo de producto' },
  { key: '3I', value: 'Kilogramo por pedazo de producto' },
  { key: '40', value: 'Mililitro por segundo' },
  { key: '41', value: 'Mililitro por minuto' },
  { key: '4B', value: 'Gorra' },
  { key: '4C', value: 'Centistokes' },
  { key: '4E', value: 'Veinte pack' },
  { key: '4G', value: 'Microlitro' },
  { key: '4H', value: 'Micra' },
  { key: '4K', value: 'Miliamperio' },
  { key: '4L', value: 'Megabyte' },
  { key: '4M', value: 'Miligramo por hora' },
  { key: '4N', value: 'Megabequerel' },
  { key: '4O', value: 'Microfaradio' },
  { key: '4P', value: 'Newton por metro' },
  { key: '4Q', value: 'Onza pulgada' },
  { key: '4R', value: 'Onza pie' },
  { key: '4T', value: 'Picofaradio' },
  { key: '4U', value: 'Libra por hora' },
  { key: '4W', value: 'Tonelada (EUA) por hora' },
  { key: '4X', value: 'Kilolitro por hora' },
  { key: '56', value: 'Sitas' },
  { key: '57', value: 'Malla' },
  { key: '58', value: ' kilogramo neto' },
  { key: '59', value: 'Parte por millón' },
  { key: '5A', value: 'Barril por minuto' },
  { key: '5B', value: 'Batch' },
  { key: '5C', value: 'Galón (US) por mil' },
  { key: '5E', value: 'Mmscf/day' },
  { key: '5F', value: 'Libra por mil' },
  { key: '5G', value: 'bomba' },
  { key: '5H', value: 'Escenario' },
  { key: '5I', value: 'Pies cúbicos estándar' },
  { key: '5J', value: 'Caballos de potencia hidráulica' },
  { key: '5K', value: 'Contar por minuto' },
  { key: '5P', value: 'Nivel sísmico' },
  { key: '5Q', value: 'Línea sísmica' },
  { key: '60', value: 'Tanto por ciento en peso' },
  { key: '61', value: 'Parte por mil millones (EUA)' },
  { key: '74', value: 'Milipascal' },
  { key: '77', value: 'Mili-pulgada' },
  { key: '80', value: 'Libra por pulgada cuadrado absoluta' },
  { key: '81', value: 'Henry' },
  { key: '85', value: 'Pie libra-fuerza' },
  { key: '87', value: 'Libra por pie cúbico' },
  { key: '89', value: 'Poise' },
  { key: '91', value: 'Stokes' },
  { key: 'A1', value: '15 ° C calorías' },
  { key: 'A10', value: 'Amperio por metro cuadrado por joule segundo' },
  { key: 'A11', value: 'Ángstrom' },
  { key: 'A12', value: 'Unidad astronómica' },
  { key: 'A13', value: 'Attojoule' },
  { key: 'A14', value: 'Barn' },
  { key: 'A15', value: 'Barn por electrovoltio' },
  { key: 'A16', value: 'Barn por electrovoltio ' },
  { key: 'A17', value: 'Barn por esteroradian' },
  { key: 'A18', value: 'Becquerel por kilogramo' },
  { key: 'A19', value: 'Becquerel por metro cúbico' },
  { key: 'A2', value: 'Amperio por centímetro' },
  { key: 'A20', value: 'Unidad térmica británica (tabla internacional) por segundo pie cuadrado grado rankine.' },
  { key: 'A21', value: 'Unidad térmica británica (tabla internacional) por libra grado rankine' },
  { key: 'A22', value: 'Unidad térmica británica (tabla internacional) por segundo pie grado rankine' },
  { key: 'A23', value: 'Unidad térmica británica (tabla internacional) por hora pie cuadrado grado rankine.' },
  { key: 'A24', value: 'Candela por metro cuadrado' },
  { key: 'A25', value: 'Caballo de vapor' },
  { key: 'A26', value: 'Culombio metro' },
  { key: 'A27', value: 'Culombio metro cuadrado por voltio' },
  { key: 'A28', value: 'Culombio por centímetro cúbico' },
  { key: 'A29', value: 'Culombio por metro cúbico' },
  { key: 'A3', value: 'Amperio por milímetro' },
  { key: 'A30', value: 'Culombio por milimetro cúbico' },
  { key: 'A31', value: 'Culombio por kilogramo-segundo' },
  { key: 'A32', value: 'Culombio por Mol' },
  { key: 'A33', value: 'Culombio por centímetro cuadrado' },
  { key: 'A34', value: 'Culombio por metro cuadrado' },
  { key: 'A35', value: 'Culombio por milímetro cuadrado' },
  { key: 'A36', value: 'Centimetro cúbico por Mol' },
  { key: 'A37', value: 'Decimetro cuadrado por Mol' },
  { key: 'A38', value: 'Cubic pooulo p' },
  { key: 'A39', value: 'Metro cúbico por kilogramo' },
  { key: 'A4', value: 'Amperio por centímetro cuadrado' },
  { key: 'A40', value: 'Metro cubbico por Mol' },
  { key: 'A41', value: 'Amperio por metro cuadrado' },
  { key: 'A42', value: 'Curie por kilogramo' },
  { key: 'A43', value: 'Tonelaje de peso muerto' },
  { key: 'A44', value: 'Decalitro' },
  { key: 'A45', value: 'Decámetro' },
  { key: 'A47', value: 'Decitex' },
  { key: 'A48', value: 'Grado rankine' },
  { key: 'A49', value: 'Negador' },
  { key: 'A5', value: 'Amperio metro cuadrado' },
  { key: 'A50', value: 'Dina segundo por centímetro cúbico' },
  { key: 'A51', value: 'Dina segundo por centímetro' },
  { key: 'A52', value: 'Dina segundo por centímetro a la quinta potencia' },
  { key: 'A53', value: 'Electrónvoltio' },
  { key: 'A54', value: 'Electrovoltio por metro' },
  { key: 'A55', value: 'Electrovoltio por metro cuadrado' },
  { key: 'A56', value: 'Electrovoltio metro cuadrado por kilogramo' },
  { key: 'A57', value: 'Ergio' },
  { key: 'A58', value: 'Erg por centímetro' },
  { key: 'A59', value: 'La cobertura de nubes 8-parte' },
  { key: 'A6', value: 'Amperio por metro cuadrado Kelvin cuadrado' },
  { key: 'A60', value: 'Erg por centímetro cúbico' },
  { key: 'A61', value: 'Erg por gramo' },
  { key: 'A62', value: 'Erg por segundo gramo' },
  { key: 'A63', value: 'Erg por segundo' },
  { key: 'A64', value: 'Erg por segundo centímetro cuadrado' },
  { key: 'A65', value: 'Erg por centímetro cuadrado segundo' },
  { key: 'A66', value: 'Erg centímetro cuadrado' },
  { key: 'A67', value: 'Erg centímetro cuadrado por gramo' },
  { key: 'A68', value: 'Exajoule' },
  { key: 'A69', value: 'Faradio por metro' },
  { key: 'A7', value: 'Amperio por milímetro cuadrado' },
  { key: 'A70', value: 'Femtojoule' },
  { key: 'A71', value: 'Femtómetro' },
  { key: 'A73', value: 'Pie por segundo al cuadrado' },
  { key: 'A74', value: 'Pie libra-fuerza por segundo' },
  { key: 'A75', value: 'Tonelada de carga' },
  { key: 'A76', value: 'Galón' },
  { key: 'A77', value: 'Gaussian CGS (Centímetro-Gram-Segundo sistema) unidad de desplazamiento' },
  { key: 'A78', value: 'Gaussiano CGS (Centímetro-Gram-Segundo sistema) unidad de corriente eléctrica' },
  { key: 'A79', value: 'Gaussian CGS (Centímetro-Gram-Segundo sistema) unidad de carga eléctrica' },
  { key: 'A8', value: 'Amperio segundo' },
  { key: 'A80', value: 'Gaussiano CGS (Centímetro-Gram-Segundo sistema) unidad de la fuerza del campo eléctrico' },
  { key: 'A81', value: 'Gaussian CGS (Centímetro-Gram-Segundo sistema) unidad de polarización eléctrica' },
  { key: 'A82', value: 'Gaussiano CGS (Centímetro-Gram-Segundo sistema) unidad de potencial eléctrico' },
  { key: 'A83', value: 'Gaussian CGS (Centímetro-Gram-Segundo sistema) unidad de magnetización' },
  { key: 'A84', value: 'GigaCulombio por metro cúbico' },
  { key: 'A85', value: 'Gigaelectrónvoltio' },
  { key: 'A86', value: 'Gigahertz' },
  { key: 'A87', value: 'GigaOhm' },
  { key: 'A88', value: 'GigaOhm metro' },
  { key: 'A89', value: 'Gigapascal' },
  { key: 'A9', value: 'Tarífa' },
  { key: 'A90', value: 'Gigawatt' },
  { key: 'A91', value: 'Grado centesimal' },
  { key: 'A93', value: 'Gramo por metro cúbico' },
  { key: 'A94', value: 'Gramo por Mol' },
  { key: 'A95', value: 'Gray' },
  { key: 'A96', value: 'Gray por segundo' },
  { key: 'A97', value: 'Hectopascal' },
  { key: 'A98', value: 'Henry por metro' },
  { key: 'A99', value: 'Bit' },
  { key: 'AA', value: 'Balón' },
  { key: 'AB', value: 'Paquete a granel' },
  { key: 'ACR', value: 'Acre' },
  { key: 'ACT', value: 'Actividad' },
  { key: 'AD', value: 'Byte' },
  { key: 'AE', value: 'Amperio por metro' },
  { key: 'AH', value: 'Minuto adicional' },
  { key: 'AI', value: 'Minuto y medio por llamada' },
  { key: 'AJ', value: 'policía' },
  { key: 'AK', value: 'Braza' },
  { key: 'AL', value: 'Línea de acceso' },
  { key: 'AMH', value: 'Amperio hora' },
  { key: 'AMP', value: 'Amperio' },
  { key: 'ANN', value: 'Año' },
  { key: 'AP', value: 'Libra de aluminio solamente' },
  { key: 'APZ', value: 'Onza troy u onza farmacéutica ' },
  { key: 'AQ', value: 'Unidad del factir anti-hemofilico.' },
  { key: 'AR', value: 'supositorio' },
  { key: 'ARE', value: 'Are' },
  { key: 'AS', value: 'Variedad' },
  { key: 'ASM', value: 'Grado alcohólico en masa' },
  { key: 'ASU', value: 'Grado alcohólico volumétrico' },
  { key: 'ATM', value: 'Atmósfera estándar' },
  { key: 'ATT', value: 'Atmósfera técnica' },
  { key: 'AW', value: 'Relleno de polvo en viales' },
  { key: 'AWG', value: 'Calibre de alambre americano' },
  { key: 'AY', value: 'Montaje' },
  { key: 'AZ', value: 'Unidad térmica británica (tabla internacional) por libra' },
  { key: 'B0', value: 'Btu por pie cúbico' },
  { key: 'B1', value: 'Barril (EUA) por día' },
  { key: 'B10', value: 'Bits por segundo' },
  { key: 'B11', value: 'Joule por kilogramo kelvin' },
  { key: 'B12', value: 'Joule por metro' },
  { key: 'B13', value: 'Joule por metro cuadrado' },
  { key: 'B14', value: 'Joule por metro a la cuarta potencia' },
  { key: 'B15', value: 'Juole por Mol' },
  { key: 'B16', value: 'Juoule por Mol kelvin' },
  { key: 'B17', value: 'Crédito' },
  { key: 'B18', value: 'Segundos joule' },
  { key: 'B19', value: 'Dígito' },
  { key: 'B2', value: 'litera' },
  { key: 'B20', value: 'Joule metro cuadrado por kologramo' },
  { key: 'B21', value: 'Kelvin por watt' },
  { key: 'B22', value: 'Kiloamperio' },
  { key: 'B23', value: 'Kiloamperio por metro cuadrado' },
  { key: 'B24', value: 'Kiloamperio por metro' },
  { key: 'B25', value: 'Kilobecquerel por metrocúbico' },
  { key: 'B26', value: 'KiloCulombio' },
  { key: 'B27', value: 'KiloCulombio por metro cúbico' },
  { key: 'B28', value: 'KiloCulombio por metro cuadrado' },
  { key: 'B29', value: 'Kiloelectrónvoltio' },
  { key: 'B3', value: 'Libra de bateo' },
  { key: 'B30', value: 'Gibibit' },
  { key: 'B31', value: 'Kilogramo metro por segundo' },
  { key: 'B32', value: 'Kilogramo metro cuadrado' },
  { key: 'B33', value: 'Kilogramo metro cuadrado por segundo' },
  { key: 'B34', value: 'Kilogramo por decímetro cúbico' },
  { key: 'B35', value: 'Kilogramo por litro' },
  { key: 'B36', value: 'Calorías (termoquímicas) por gramo' },
  { key: 'B37', value: 'Kilogramo de fuerza' },
  { key: 'B38', value: 'Kilogramo-metro de la fuerza' },
  { key: 'B39', value: 'Kilogramo-fuerza del metro por segundo' },
  { key: 'B4', value: 'Barril, unidad imperial' },
  { key: 'B40', value: 'Kilogramo de fuerza por metro cuadrado' },
  { key: 'B41', value: 'Kilojoule por kelvin' },
  { key: 'B42', value: 'Kilojoule por kilogramo' },
  { key: 'B43', value: 'Kilojoule por kilogramo kelvin' },
  { key: 'B44', value: 'Kilojoule por Mol ' },
  { key: 'B45', value: 'KiloMol' },
  { key: 'B46', value: 'KiloMol por metro cúbico' },
  { key: 'B47', value: 'Kilonewton' },
  { key: 'B48', value: 'Kilonewton metro' },
  { key: 'B49', value: 'KiloOhm' },
  { key: 'B5', value: 'palanquilla' },
  { key: 'B50', value: 'KiloOhm metro' },
  { key: 'B51', value: 'KiloLibra' },
  { key: 'B52', value: 'Kilosegundo' },
  { key: 'B53', value: 'Kilosiemens' },
  { key: 'B54', value: 'Kilosiemens por metro' },
  { key: 'B55', value: 'Kilovoltio por metro' },
  { key: 'B56', value: 'Kiloweber por metro' },
  { key: 'B57', value: 'Año luz' },
  { key: 'B58', value: 'Litro por Mol' },
  { key: 'B59', value: 'Lumen hora' },
  { key: 'B6', value: 'Bollo' },
  { key: 'B60', value: 'Lumen por metro cuadrado' },
  { key: 'B61', value: 'Luminosidad por watt' },
  { key: 'B62', value: 'Lumen segundo' },
  { key: 'B63', value: 'Hora de luz' },
  { key: 'B64', value: 'Segundo de luz' },
  { key: 'B65', value: 'Maxwell' },
  { key: 'B66', value: 'Megaamperio por metro cuadrado' },
  { key: 'B67', value: 'Megabecquerel por kilogramo' },
  { key: 'B68', value: 'Gigabit' },
  { key: 'B69', value: 'MegaCulombio por metro cúbico' },
  { key: 'B7', value: 'Ciclo' },
  { key: 'B70', value: 'MegaCulombio por metro cuadrado' },
  { key: 'B71', value: 'Megaelectrónvoltio' },
  { key: 'B72', value: 'Megagramo por metro cúbico' },
  { key: 'B73', value: 'Meganewton' },
  { key: 'B74', value: 'Meganewton metro' },
  { key: 'B75', value: 'MegaOhm' },
  { key: 'B76', value: 'MegaOhm metro' },
  { key: 'B77', value: 'Megasiemens por metro' },
  { key: 'B78', value: 'Megavoltio ' },
  { key: 'B79', value: 'Megavoltio por metro' },
  { key: 'B8', value: 'Joule por metro cúbico' },
  { key: 'B80', value: 'Gigabit por segundo' },
  { key: 'B81', value: 'Reciprocidad del metro cuadrado, reciprocidad del segundo' },
  { key: 'B82', value: 'Pulgadas por pie lineal' },
  { key: 'B83', value: 'Metro a la cuarta potencia' },
  { key: 'B84', value: 'Microamperio' },
  { key: 'B85', value: 'Microbar' },
  { key: 'B86', value: 'MicroCulombio' },
  { key: 'B87', value: 'MicroCulombio por metro cúbico' },
  { key: 'B88', value: 'MicroCulombio por metro cuadrado' },
  { key: 'B89', value: 'Microfaradio por metro' },
  { key: 'B9', value: 'Batt' },
  { key: 'B90', value: 'Microhenry' },
  { key: 'B91', value: 'Microhenry por metro' },
  { key: 'B92', value: 'Micronewton' },
  { key: 'B93', value: 'Micronewton metro' },
  { key: 'B94', value: 'Micro Ohm' },
  { key: 'B95', value: 'MicroOhm metro' },
  { key: 'B96', value: 'Micropascal' },
  { key: 'B97', value: 'Microrradián' },
  { key: 'B98', value: 'Microsegundo' },
  { key: 'B99', value: 'Microsiemens' },
  { key: 'BAR', value: 'Bar [unidad de presión]' },
  { key: 'BB', value: 'Caja base' },
  { key: 'BFT', value: 'Tablero de pies' },
  { key: 'BH', value: 'Cepillo' },
  { key: 'BHP', value: 'Potencia al freno' },
  { key: 'BIL', value: 'Billon' },
  { key: 'BLD', value: 'Barril seco (EUA)' },
  { key: 'BLL', value: 'Barril (EUA)' },
  { key: 'BP', value: 'Tabledo de cien pies' },
  { key: 'BPM', value: 'Latidos por minuto' },
  { key: 'BQL', value: 'Becquerel' },
  { key: 'BTU', value: 'Unidad térmica británica (tabla internacional)' },
  { key: 'BUA', value: 'Bushel (EUA)' },
  { key: 'BUI', value: 'Bushel (UK)' },
  { key: 'BW', value: 'Peso base' },
  { key: 'BZ', value: 'Millones de BTUs' },
  { key: 'C0', value: 'Llamada' },
  { key: 'C1', value: 'Libra de producto compuesto (peso total)' },
  { key: 'C10', value: 'Milifaradio' },
  { key: 'C11', value: 'Miligalón' },
  { key: 'C12', value: 'Miligramo por metro' },
  { key: 'C13', value: 'MilliGray' },
  { key: 'C14', value: 'Milihenry' },
  { key: 'C15', value: 'Milijoule' },
  { key: 'C16', value: 'Milímetro por segundo' },
  { key: 'C17', value: 'Milímetro cuadrado por segundo' },
  { key: 'C18', value: 'MiliMol' },
  { key: 'C19', value: 'Mol por kilogramo' },
  { key: 'C2', value: 'Carset' },
  { key: 'C20', value: 'Milinewton' },
  { key: 'C21', value: 'Kibibit' },
  { key: 'C22', value: 'Milinewton por metro' },
  { key: 'C23', value: 'MiliOhm metro' },
  { key: 'C24', value: 'Milipascal segundo' },
  { key: 'C25', value: 'Milirradián' },
  { key: 'C26', value: 'Milisegundo' },
  { key: 'C27', value: 'Milisiemens' },
  { key: 'C28', value: 'MilliSievert' },
  { key: 'C29', value: 'Militesla' },
  { key: 'C3', value: 'Microvoltios por metro' },
  { key: 'C30', value: 'Milivoltio por metro' },
  { key: 'C31', value: 'Miliwatt' },
  { key: 'C32', value: 'Miliwatt por metro cuadrado' },
  { key: 'C33', value: 'Miliweber' },
  { key: 'C34', value: 'Mol' },
  { key: 'C35', value: 'Mol por decimetro cúbico' },
  { key: 'C36', value: 'Mol por metro cúbico' },
  { key: 'C37', value: 'Kilobits' },
  { key: 'C38', value: 'Mol por litro' },
  { key: 'C39', value: 'Nanoamperio' },
  { key: 'C4', value: 'partido de carga' },
  { key: 'C40', value: 'NanoCulombio' },
  { key: 'C41', value: 'Nanofaradio' },
  { key: 'C42', value: 'Nanofaradio por metro' },
  { key: 'C43', value: 'Nanohenry' },
  { key: 'C44', value: 'Nanohenry por metro' },
  { key: 'C45', value: 'Nanómetro' },
  { key: 'C46', value: 'NanoOhm metro' },
  { key: 'C47', value: 'Nanosegundo' },
  { key: 'C48', value: 'Nanotesla' },
  { key: 'C49', value: 'Nanowatt' },
  { key: 'C5', value: 'Costo' },
  { key: 'C50', value: 'Neperio' },
  { key: 'C51', value: 'Neperio por segundo' },
  { key: 'C52', value: 'Picómetro' },
  { key: 'C53', value: 'Newton metro segundo' },
  { key: 'C54', value: 'Newton metro cuadrado por kilogramo cuadrado' },
  { key: 'C55', value: 'Newton por metro cuadrado' },
  { key: 'C56', value: 'Newton por milimetro cuadrado' },
  { key: 'C57', value: 'Newton segundo' },
  { key: 'C58', value: 'Segundos newton por metro' },
  { key: 'C59', value: 'Octava' },
  { key: 'C6', value: 'celda' },
  { key: 'C60', value: 'Ohm centímetro' },
  { key: 'C61', value: 'Ohm metro' },
  { key: 'C62', value: 'Uno' },
  { key: 'C63', value: 'Pársec' },
  { key: 'C64', value: 'Pascal por kelvin' },
  { key: 'C65', value: 'Pascal segundo' },
  { key: 'C66', value: 'Segundos pascal por metro cúbico' },
  { key: 'C67', value: 'Segundos pascal por metro ' },
  { key: 'C68', value: 'Petajoule' },
  { key: 'C69', value: 'Phon' },
  { key: 'C7', value: 'Centipoise' },
  { key: 'C70', value: 'Picoamperio' },
  { key: 'C71', value: 'PicoCulombio' },
  { key: 'C72', value: 'Picofaradio por metro' },
  { key: 'C73', value: 'Picohenry' },
  { key: 'C74', value: 'Kilobits por segundo' },
  { key: 'C75', value: 'Picowatt' },
  { key: 'C76', value: 'Picowatt  por metro cuadrado' },
  { key: 'C77', value: 'Calibre de libra' },
  { key: 'C78', value: 'Libra fuerza' },
  { key: 'C79', value: 'Kilovoltios horas amperios' },
  { key: 'C8', value: 'MilliCulombio por kilogramo' },
  { key: 'C80', value: 'Rad' },
  { key: 'C81', value: 'Radián' },
  { key: 'C82', value: 'Radianmetro cuadrado por Mol' },
  { key: 'C83', value: 'Rradian metro cuadrado por kilogramo' },
  { key: 'C84', value: 'Radían por metro' },
  { key: 'C85', value: 'Reciprocidad Ámstrong' },
  { key: 'C86', value: 'Reciprocidad del metro cúbico' },
  { key: 'C87', value: 'Reciprocidad metro cúbico por segundo' },
  { key: 'C88', value: 'Recíproco joule por metro cúbico' },
  { key: 'C89', value: 'Henry recíproco' },
  { key: 'C9', value: 'Grupo bobinas' },
  { key: 'C90', value: 'Recíproco Henry' },
  { key: 'C91', value: 'Recíprocidad de kelvin ó kelvin a la potencia menos 1' },
  { key: 'C92', value: 'Reciprocidad Metro' },
  { key: 'C93', value: 'Reciprocidad Metro cuadrado' },
  { key: 'C94', value: 'Reciprocidad Minuto' },
  { key: 'C95', value: 'Reciprocidad Mol' },
  { key: 'C96', value: 'Reciprocidad Pascal o pascal a la potencia menos 1 ' },
  { key: 'C97', value: 'Reciprocidad Segundo' },
  { key: 'C98', value: 'Segundo recíproco por metro cúbico' },
  { key: 'C99', value: 'Reciprocidad Segundo por metro cuadrado' },
  { key: 'CCT', value: 'Capacidad de carga en toneladas métricas' },
  { key: 'CDL', value: 'Candela' },
  { key: 'CE', value: 'Cada mes' },
  { key: 'CEL', value: 'Grados celsius' },
  { key: 'CEN', value: 'Centenar' },
  { key: 'CG', value: 'Tarjeta' },
  { key: 'CGM', value: 'Centígramo' },
  { key: 'CK', value: 'Conector' },
  { key: 'CKG', value: 'Culombio por kilogramo' },
  { key: 'CLF', value: 'Cientos de hojas' },
  { key: 'CLT', value: 'Centilitro' },
  { key: 'CMK', value: 'Centímetro cuadrado' },
  { key: 'CMQ', value: 'Centímetro cúbico' },
  { key: 'CMT', value: 'Centímetro' },
  { key: 'CNP', value: 'Cientos de paquetes' },
  { key: 'CNT', value: 'Cental (UK)' },
  { key: 'COU', value: 'Culombio' },
  { key: 'CTG', value: 'Contenido en gramos' },
  { key: 'CTM', value: 'Quilatage métrico' },
  { key: 'CTN', value: 'Tonelada de contenido (métrica)' },
  { key: 'CUR', value: 'Curie' },
  { key: 'CWA', value: 'Hundred pound' },
  { key: 'CWI', value: 'Hundredweight' },
  { key: 'CZ', value: 'Combo' },
  { key: 'D03', value: 'Kilovatio hora por hora' },
  { key: 'D04', value: 'Lot [unidad de peso]' },
  { key: 'D1', value: 'Segundo recíproco por estereorradián' },
  { key: 'D10', value: 'Siemens por metro' },
  { key: 'D11', value: 'Mebibit' },
  { key: 'D12', value: 'Siemens metro cuadrado por Mol' },
  { key: 'D13', value: 'Sievert' },
  { key: 'D14', value: 'Yarda mil lineal' },
  { key: 'D15', value: 'Sone' },
  { key: 'D16', value: 'Centimetro cuadrado por erg' },
  { key: 'D17', value: 'Centimetro cuadrado por esteroradian erg' },
  { key: 'D18', value: 'Metro kelvin' },
  { key: 'D19', value: 'Metro cuadrado kelvin por watt.' },
  { key: 'D2', value: 'Segundo recíproco por estereorradián metro cuadrado' },
  { key: 'D20', value: 'Metro cuadrado por joule' },
  { key: 'D21', value: 'Metro cuadrado por kilogramo' },
  { key: 'D22', value: 'Metro cuadrado por Mol' },
  { key: 'D23', value: 'Gramo pluma (proteína)' },
  { key: 'D24', value: 'Metro cuadrado por esteroradian' },
  { key: 'D25', value: 'Metro cuadrado por esteroradian joule' },
  { key: 'D26', value: 'Metro cuadrado por voltiosegundo' },
  { key: 'D27', value: 'Estereorradían' },
  { key: 'D28', value: 'sifón' },
  { key: 'D29', value: 'Terahertz' },
  { key: 'D30', value: 'Terajoule' },
  { key: 'D31', value: 'Terawatt' },
  { key: 'D32', value: 'Terawatt hora ' },
  { key: 'D33', value: 'Tesla' },
  { key: 'D34', value: 'Tex' },
  { key: 'D35', value: 'Calorías (termoquímicas)' },
  { key: 'D36', value: 'Megabit' },
  { key: 'D37', value: 'Calorías (termoquímicas) por gramo de kelvin' },
  { key: 'D38', value: 'Calorías (termoquímicas) por segundo centímetro kelvin' },
  { key: 'D39', value: 'Calorías (termoquímicas) por segundo centímetro cuadrado kelvin' },
  { key: 'D40', value: 'Mil litros' },
  { key: 'D41', value: 'Tonelada por metro cúbico' },
  { key: 'D42', value: 'Año tropical' },
  { key: 'D43', value: 'Unidad de masa atómica unificada' },
  { key: 'D44', value: 'Var' },
  { key: 'D45', value: 'Voltio cuadrado por kelvin cuadrado' },
  { key: 'D46', value: 'Voltioio-amperio' },
  { key: 'D47', value: 'Voltio por centímetro' },
  { key: 'D48', value: 'Voltio por Kelvin ' },
  { key: 'D49', value: 'Millivoltio por Kelvin ' },
  { key: 'D5', value: 'Kilogramo por centímetro cuadrado' },
  { key: 'D50', value: 'Voltio por metro' },
  { key: 'D51', value: 'Voltio por milímetro' },
  { key: 'D52', value: 'Watt por kelvin' },
  { key: 'D53', value: 'Watt por metro kelvin' },
  { key: 'D54', value: 'Watt por metro cuadrado' },
  { key: 'D55', value: 'Watt por metro cuadrado kelvin' },
  { key: 'D56', value: 'Watt por metro cuadrado kelvin a la cuarta potencia' },
  { key: 'D57', value: 'Watt por estereorradián' },
  { key: 'D58', value: 'Watt por estereorradián metro cuadrado' },
  { key: 'D59', value: 'Weber por metro' },
  { key: 'D6', value: 'Roentgen por segundo' },
  { key: 'D60', value: 'Weber por milímetro' },
  { key: 'D61', value: 'Minuto [unidad de ángulo]' },
  { key: 'D62', value: 'Segundo [unidad de ángulo]' },
  { key: 'D63', value: 'Libro' },
  { key: 'D64', value: 'bloquear' },
  { key: 'D65', value: 'Redondo' },
  { key: 'D66', value: 'casete' },
  { key: 'D67', value: 'Dólar por hora' },
  { key: 'D68', value: 'Número de palabras' },
  { key: 'D69', value: 'Pulgada a la cuarta potencia' },
  { key: 'D7', value: 'Sandwich' },
  { key: 'D70', value: 'Calorías (tabla internacional)' },
  { key: 'D71', value: 'Calorías (tabla internacional) por segundo centímetro kelvin' },
  { key: 'D72', value: 'Calorías (tabla internacional) por segundo centímetro cuadrado kelvin' },
  { key: 'D73', value: 'Joule metro cuadrado' },
  { key: 'D74', value: 'Kilogramo por Mol' },
  { key: 'D75', value: 'Calorías (tabla internacional) por gramo' },
  { key: 'D76', value: 'Calorías (tabla internacional) por gramo de kelvin' },
  { key: 'D77', value: 'MegaCulombio' },
  { key: 'D78', value: 'Megajoule por segundo' },
  { key: 'D79', value: 'Viga' },
  { key: 'D8', value: 'Draize score' },
  { key: 'D80', value: 'Microwatt' },
  { key: 'D81', value: 'Microtesla' },
  { key: 'D82', value: 'Microvoltio' },
  { key: 'D83', value: 'Milinewton metro' },
  { key: 'D85', value: 'Microwatt por metro cuadrado' },
  { key: 'D86', value: 'MiliCulombio' },
  { key: 'D87', value: 'MiliMol por kilogramo' },
  { key: 'D88', value: 'MiliCulombio por metro cúbico' },
  { key: 'D89', value: 'MiliCulombio por metro cuadrado' },
  { key: 'D9', value: 'Dina por centímetro cuadrado' },
  { key: 'D90', value: 'Metro cúbico (neta)' },
  { key: 'D91', value: 'Rem' },
  { key: 'D92', value: 'banda' },
  { key: 'D93', value: 'Segundo por metro cúbico' },
  { key: 'D94', value: 'Segundo por metro cúbico Radian' },
  { key: 'D95', value: 'Joule por gramo' },
  { key: 'D96', value: 'Libra bruta' },
  { key: 'D98', value: 'Libra masiva' },
  { key: 'D99', value: 'manga' },
  { key: 'DAA', value: 'Decar' },
  { key: 'DAD', value: 'Decena de días' },
  { key: 'DAY', value: 'Día' },
  { key: 'DB', value: 'Libra seca' },
  { key: 'DC', value: 'Disco (disco)' },
  { key: 'DD', value: 'Grado [unidad de ángulo]' },
  { key: 'DE', value: 'Acuerdo' },
  { key: 'DEC', value: 'Década' },
  { key: 'DG', value: 'Decigramo' },
  { key: 'DI', value: 'dispensador' },
  { key: 'DJ', value: 'Decagramo' },
  { key: 'DLT', value: 'Decilitro' },
  { key: 'DMA', value: 'Decámetro cúbico' },
  { key: 'DMK', value: 'Decímetro cuadrado ' },
  { key: 'DMO', value: 'Kiloliter norma' },
  { key: 'DMQ', value: 'Decímetro cúbico' },
  { key: 'DMT', value: 'Decímetro' },
  { key: 'DN', value: 'Decinewton metro' },
  { key: 'DPC', value: 'Docenas de piezas' },
  { key: 'DPR', value: 'Docenas de pares' },
  { key: 'DPT', value: 'Peso de desplazamiento' },
  { key: 'DQ', value: 'registro de datos' },
  { key: 'DRA', value: 'Dram (EUA)' },
  { key: 'DRI', value: 'Dram (UK)' },
  { key: 'DRL', value: 'Docena de rodillos' },
  { key: 'DRM', value: 'Drachm (UK)' },
  { key: 'DS', value: 'monitor' },
  { key: 'DT', value: 'Tonelada seca' },
  { key: 'DTN', value: 'Decitonelada métrica' },
  { key: 'DU', value: 'dina' },
  { key: 'DWT', value: 'Pennyweight' },
  { key: 'Dx', value: 'Dina por centímetro' },
  { key: 'DY', value: 'Libro de directorio' },
  { key: 'DZN', value: 'Docena' },
  { key: 'DZP', value: 'Docena de paquete' },
  { key: 'E01', value: 'Newton por centímetro cuadrado' },
  { key: 'E07', value: 'Megawatt hora por hora' },
  { key: 'E08', value: 'Megavatios por hertz' },
  { key: 'E09', value: 'Miliamperio hora' },
  { key: 'E10', value: 'Día de grado' },
  { key: 'E11', value: 'Gigacalorie' },
  { key: 'E12', value: 'Mille' },
  { key: 'E14', value: 'Kilocaloría (tabla internacional)' },
  { key: 'E15', value: 'Kilocaloría (termoquímica) por hora' },
  { key: 'E16', value: 'Millón de btu (ti) por hora' },
  { key: 'E17', value: 'Pie cúbico por segundo' },
  { key: 'E18', value: 'Tonelada por hora' },
  { key: 'E19', value: 'Ping' },
  { key: 'E20', value: 'Megabit por segundo' },
  { key: 'E21', value: 'Shares' },
  { key: 'E22', value: 'Tue' },
  { key: 'E23', value: 'Neumático' },
  { key: 'E25', value: 'Unidad activa' },
  { key: 'E27', value: 'Dosis' },
  { key: 'E28', value: 'Tonelada seca de aire' },
  { key: 'E3', value: 'remolque' },
  { key: 'E30', value: 'Hebra' },
  { key: 'E31', value: 'Metro cuadrado por litro' },
  { key: 'E32', value: 'Litros por hora' },
  { key: 'E33', value: 'Por mil pies' },
  { key: 'E34', value: 'Gigabyte' },
  { key: 'E35', value: 'Terabyte' },
  { key: 'E36', value: 'Petabyte' },
  { key: 'E37', value: 'Pixel' },
  { key: 'E38', value: 'Megapíxeles' },
  { key: 'E39', value: 'Puntos por pulgada' },
  { key: 'E4', value: 'Kilo bruto' },
  { key: 'E40', value: 'Parte por cien mil' },
  { key: 'E41', value: 'Kilogramo-fuerza por milímetro cuadrado' },
  { key: 'E42', value: 'Kilogramo-fuerza por centímetro cuadrado' },
  { key: 'E43', value: 'Joule por centímetro cuadrado' },
  { key: 'E44', value: 'Metros kilogramo-fuerza por centímetro cuadrado' },
  { key: 'E45', value: 'MiliOhm' },
  { key: 'E46', value: 'Kilovatio hora por metro cúbico' },
  { key: 'E47', value: 'Kilovatio hora por kelvin' },
  { key: 'E48', value: 'Unidad de servicio' },
  { key: 'E49', value: 'Día de trabajo' },
  { key: 'E5', value: 'Tonelada métrica larga' },
  { key: 'E50', value: 'Unidad de cuenta' },
  { key: 'E51', value: 'Trabajo' },
  { key: 'E52', value: 'Run foot' },
  { key: 'E53', value: 'Prueba' },
  { key: 'E54', value: 'Viaje' },
  { key: 'E55', value: 'Utilizar' },
  { key: 'E56', value: 'Bien' },
  { key: 'E57', value: 'Zona' },
  { key: 'E58', value: 'Exabit por segundo' },
  { key: 'E59', value: 'Exbibyte' },
  { key: 'E60', value: 'Pebibyte' },
  { key: 'E61', value: 'Tebibyte' },
  { key: 'E62', value: 'Gibibyte' },
  { key: 'E63', value: 'Mebibyte' },
  { key: 'E64', value: 'Kibibyte' },
  { key: 'E65', value: 'Exbibit por metro' },
  { key: 'E66', value: 'Exbibit por metro cuadrado' },
  { key: 'E67', value: 'Exbibit por metro cúbico' },
  { key: 'E68', value: 'Gigabyte por segundo' },
  { key: 'E69', value: 'Gibibit por metro' },
  { key: 'E70', value: 'Gibibit por metro cuadrado' },
  { key: 'E71', value: 'Gibibit por metro cúbico' },
  { key: 'E72', value: 'Kibibit por metro' },
  { key: 'E73', value: 'Kibibit por metro cuadrado' },
  { key: 'E74', value: 'Kikibit por metro cúbico.' },
  { key: 'E75', value: 'Mebbit por metro.' },
  { key: 'E76', value: 'Mebbitt por metro cuadrado.' },
  { key: 'E77', value: 'Mebbit por metro cúbico. ' },
  { key: 'E78', value: 'Petabit' },
  { key: 'E79', value: 'Pebibit por segundo.' },
  { key: 'E80', value: 'Pebibit por metro.' },
  { key: 'E81', value: 'Pebibit por metro cuadrado.' },
  { key: 'E82', value: 'Pebibit por metro cúbico.' },
  { key: 'E83', value: 'Tebibit.' },
  { key: 'E84', value: 'Tebibit por segundo' },
  { key: 'E85', value: 'Tebibit por metro.' },
  { key: 'E86', value: 'Tebibit por metro cúbico.' },
  { key: 'E87', value: 'Tebibit por metro cuadrado' },
  { key: 'E88', value: 'Bit por metro' },
  { key: 'E89', value: 'Bit por metro cuadrado' },
  { key: 'E90', value: 'Centímetro recíproco' },
  { key: 'E91', value: 'Día recíproco' },
  { key: 'E92', value: 'Decímetro cúbico por hora' },
  { key: 'E93', value: 'Kilogramo por hora' },
  { key: 'E94', value: 'KiloMol por segundo' },
  { key: 'E95', value: 'Mol por segundo' },
  { key: 'E96', value: 'Grado por segundo' },
  { key: 'E97', value: 'Mililitro por gadro celsius metro' },
  { key: 'E98', value: 'Grado celsius por kelvin' },
  { key: 'E99', value: 'Hectopascal por bar' },
  { key: 'EA', value: 'Elemento' },
  { key: 'EB', value: 'Casilla de correo electrónico' },
  { key: 'EP', value: 'Paquete de once' },
  { key: 'EQ', value: 'Galón equivalente' },
  { key: 'F01', value: 'Bit por metro cúbico' },
  { key: 'F02', value: 'Kelvin por kelvin' },
  { key: 'F03', value: 'Kilopascal por bar' },
  { key: 'F04', value: 'Milibar por bar' },
  { key: 'F05', value: 'Megapascal por bar' },
  { key: 'F06', value: 'Poise por bar' },
  { key: 'F07', value: 'Pascal por bar' },
  { key: 'F08', value: 'Miliamperio por pulgada' },
  { key: 'F1', value: 'Mil pies cúbicos por día' },
  { key: 'F10', value: 'Kelvin por hora' },
  { key: 'F11', value: 'Kelvin por minuto' },
  { key: 'F12', value: 'Kelvin por segundo' },
  { key: 'F13', value: 'Slug' },
  { key: 'F14', value: 'Gramo por kelvin' },
  { key: 'F15', value: 'Kilogramo por kelvin' },
  { key: 'F16', value: 'Miligramo por kelvin' },
  { key: 'F17', value: 'Libra fuerza por pie' },
  { key: 'F18', value: 'Kilogramo centímetro cuadrado' },
  { key: 'F19', value: 'Kilogramo milimetro cuadrado' },
  { key: 'F20', value: 'Libra pulgada cuadrada' },
  { key: 'F21', value: 'Libra fuerza pulgada' },
  { key: 'F22', value: 'Libra fuerza por pie entre amperio' },
  { key: 'F23', value: 'Gramo por decímetro cúbico' },
  { key: 'F24', value: 'Kilogramo por kiloMol' },
  { key: 'F25', value: 'Gramo por hertz' },
  { key: 'F26', value: 'Gramo por día' },
  { key: 'F27', value: 'Gramo por hora' },
  { key: 'F28', value: 'Gramo por minuto' },
  { key: 'F29', value: 'Gramo por segundo' },
  { key: 'F30', value: 'Kilogramo por día' },
  { key: 'F31', value: 'Kilogramo por minuto' },
  { key: 'F32', value: 'Miligramo por dia' },
  { key: 'F33', value: 'Miligramo por minuto' },
  { key: 'F34', value: 'Miligramo por segundo' },
  { key: 'F35', value: 'Gramo por día kelvin' },
  { key: 'F36', value: 'Gramo por hora kelvin' },
  { key: 'F37', value: 'Gramo por minuto kelvin' },
  { key: 'F38', value: 'Gramo por segundo kelvin' },
  { key: 'F39', value: 'Kilogramo por día kelvin' },
  { key: 'F40', value: 'Kilogramo por hora kelvin' },
  { key: 'F41', value: 'Kilogramo por minuto kelvin' },
  { key: 'F42', value: 'Kilogramo por segundo kelvin' },
  { key: 'F43', value: 'Miligramo por día kelvin' },
  { key: 'F44', value: 'Miligramo por hora kelvin' },
  { key: 'F45', value: 'Miligramo por minuto kelvin' },
  { key: 'F46', value: 'Miligramo por segundo kelvin' },
  { key: 'F47', value: 'Newton por milímetro' },
  { key: 'F48', value: 'Libra fuerza por pulgada' },
  { key: 'F49', value: 'Rod (Unidad de distancia)' },
  { key: 'F50', value: 'Micrómetro por kelvin' },
  { key: 'F51', value: 'Centímetro por kelvin' },
  { key: 'F52', value: 'Metro por kelvin' },
  { key: 'F53', value: 'Mililitro por kelvin' },
  { key: 'F54', value: 'MiliOhm por metro' },
  { key: 'F55', value: 'Ohm por milla (milla estatal)' },
  { key: 'F56', value: 'Ohm por kilómetro' },
  { key: 'F57', value: 'Miliamperio por libra-fuerza por pulgada cuadrada' },
  { key: 'F58', value: 'Bar recíproco' },
  { key: 'F59', value: 'Miliamperio por bar' },
  { key: 'F60', value: 'Grado celsius por bar' },
  { key: 'F61', value: 'Kelvin por bar' },
  { key: 'F62', value: 'Gramo por día bar' },
  { key: 'F63', value: 'Gramo por hora bar' },
  { key: 'F64', value: 'Gramo por minuto bar' },
  { key: 'F65', value: 'Gramo por segundo bar' },
  { key: 'F66', value: 'Kililogramo por día bar' },
  { key: 'F67', value: 'Kilogramo por hora bar' },
  { key: 'F68', value: 'Kilogramo por minuto bar' },
  { key: 'F69', value: 'Kilogramo por segundo bar' },
  { key: 'F70', value: 'Miligramo por día bar' },
  { key: 'F71', value: 'Miligramo por hora bar' },
  { key: 'F72', value: 'Miligramo por minuto bar' },
  { key: 'F73', value: 'Miligramo por segundo bar' },
  { key: 'F74', value: 'Gramo por bar' },
  { key: 'F75', value: 'Miligramo por bar' },
  { key: 'F76', value: 'Miliamperio por milímetro' },
  { key: 'F77', value: 'Pascal segundo por kelvin' },
  { key: 'F78', value: 'Pulgada de agua' },
  { key: 'F79', value: 'Pulgada de mercurio' },
  { key: 'F80', value: 'Caballos de fuerza de agua' },
  { key: 'F81', value: 'Bar por kelvin' },
  { key: 'F82', value: 'Hectopascal por kelvin' },
  { key: 'F83', value: 'Kilopascal por kelvin' },
  { key: 'F84', value: 'Milibar por kelvin' },
  { key: 'F85', value: 'Megapascal por kelvin' },
  { key: 'F86', value: 'Poise por kelvin' },
  { key: 'F87', value: 'Voltio por litro minuto' },
  { key: 'F88', value: 'Newton centímetro' },
  { key: 'F89', value: 'Newton metro por grados' },
  { key: 'F9', value: 'Fibra por centímetro cúbico de aire' },
  { key: 'F90', value: 'Newton metro por amperio' },
  { key: 'F91', value: 'Bar litro por segundo' },
  { key: 'F92', value: 'Bar metro cúbico por segundo' },
  { key: 'F93', value: 'Hectopascal litro por segundo' },
  { key: 'F94', value: 'Hectopascal metro cúbico por segundo' },
  { key: 'F95', value: 'Milibar litro por segundo' },
  { key: 'F96', value: 'Milibar metro cúbico por segundo' },
  { key: 'F97', value: 'Megapascal litro por segundo' },
  { key: 'F98', value: 'Megapascal metro cúbico por segundo' },
  { key: 'F99', value: 'Pascal litro por segundo' },
  { key: 'FAH', value: 'Grado fahrenheit' },
  { key: 'FAR', value: 'Farad' },
  { key: 'FB', value: 'campo' },
  { key: 'FBM', value: 'Medidor de fibra' },
  { key: 'FC', value: 'Mil pies cúbicos' },
  { key: 'FD', value: 'Millones de partículas por pie cúbico' },
  { key: 'FE', value: 'Pie de pista' },
  { key: 'FF', value: 'Cien metros cúbicos' },
  { key: 'FG', value: 'Parche transdérmico' },
  { key: 'FH', value: 'MicroMol' },
  { key: 'FIT', value: 'Fallas en el tiempo' },
  { key: 'FL', value: 'Flake ton' },
  { key: 'FM', value: 'Millones de pies cúbicos' },
  { key: 'FOT', value: 'Pie' },
  { key: 'FP', value: 'Libra por pie cuadrado' },
  { key: 'FR', value: 'Pie por minuto' },
  { key: 'FS', value: 'Pie por segundo' },
  { key: 'FTK', value: 'Pie cuadrado' },
  { key: 'FTQ', value: 'Pie cúbico' },
  { key: 'G01', value: 'Pascal metro cúbico por segundo' },
  { key: 'G04', value: 'Centímetro por bar' },
  { key: 'G05', value: 'Metro por bar ' },
  { key: 'G06', value: 'Milímetro por bar ' },
  { key: 'G08', value: 'Pulgada cuadrada por segundo' },
  { key: 'G09', value: 'Metro cuadrado por segundo kelvin' },
  { key: 'G10', value: 'Stokes por kelvin' },
  { key: 'G11', value: 'Gramo por centímetro cúbico bar' },
  { key: 'G12', value: 'Gramo por decímetro cúbico bar' },
  { key: 'G13', value: 'Gramo por litro bar' },
  { key: 'G14', value: 'Gramo por metro cúbico bar' },
  { key: 'G15', value: 'Gramo por mililitro bar' },
  { key: 'G16', value: 'Kilogramo por centímetro cúbico bar' },
  { key: 'G17', value: 'Kilogramo por litro bar' },
  { key: 'G18', value: 'Kilogramo por metro cúbico bar' },
  { key: 'G19', value: 'Newton metro por kilogramo' },
  { key: 'G2', value: 'Galón (EUA) por minuto' },
  { key: 'G20', value: 'Libra-fuerza pie por libra' },
  { key: 'G21', value: 'Taza (unidad de volumen)' },
  { key: 'G23', value: 'Peck' },
  { key: 'G24', value: 'Cucharada (estados unidos)' },
  { key: 'G25', value: 'Cucharilla (estados unidos)' },
  { key: 'G26', value: 'Estere' },
  { key: 'G27', value: 'Centímetro cúbico por kelvin' },
  { key: 'G28', value: 'Litro por kelvin' },
  { key: 'G29', value: 'Metro cúbico por kelvin' },
  { key: 'G3', value: 'Galón (RU) por minuto' },
  { key: 'G30', value: 'Mililitro por klevin' },
  { key: 'G31', value: 'Kilogramo por centímetro cúbico' },
  { key: 'G32', value: 'Onza (avoirdupois) por yarda cúbica' },
  { key: 'G33', value: 'Gramo por centímetro cúbico kelvin' },
  { key: 'G34', value: 'Gramo por decímetro cúbico kelvin' },
  { key: 'G35', value: 'Gramo por litro kelvin' },
  { key: 'G36', value: 'Gramo por metro cúbico kelvin' },
  { key: 'G37', value: 'Gramo por mililitro kelvin' },
  { key: 'G38', value: 'Kilogramo por centímetro cúbico kelvin' },
  { key: 'G39', value: 'Kilogramo por litro kelvin' },
  { key: 'G40', value: 'Kilogramo por metro cúbico kelvin' },
  { key: 'G41', value: 'Metro cuadrado por segundo bar' },
  { key: 'G42', value: 'Microsiemens por centímetro' },
  { key: 'G43', value: 'Microsiemens por metro' },
  { key: 'G44', value: 'Nanosiemens por centímetro' },
  { key: 'G45', value: 'Nanosiemens por metro' },
  { key: 'G46', value: 'Stokes por bar' },
  { key: 'G47', value: 'Centímetro cúbico por día' },
  { key: 'G48', value: 'Centímetro cúbico por hora' },
  { key: 'G49', value: 'Centímetro cúbico por minuto' },
  { key: 'G50', value: 'Galón por hora' },
  { key: 'G51', value: 'Litro por segundo' },
  { key: 'G52', value: 'Metro cúbico por día' },
  { key: 'G53', value: 'Metro cúbico por minuto' },
  { key: 'G54', value: 'Mililitro por día' },
  { key: 'G55', value: 'Mililitro por hora' },
  { key: 'G56', value: 'Pulgada cúbica por hora' },
  { key: 'G57', value: 'Pulgada cúbica por minuto' },
  { key: 'G58', value: 'Pulgada cúbica por segundo' },
  { key: 'G59', value: 'Miliamperio por litro minuto' },
  { key: 'G60', value: 'Voltio por bar' },
  { key: 'G61', value: 'Centímetro cúbico por día kelvin' },
  { key: 'G62', value: 'Centímetro cúbico por hora kelvin' },
  { key: 'G63', value: 'Centímetro cúbico por minuto kelvin' },
  { key: 'G64', value: 'Centímetro cúbico por segundo kelvin' },
  { key: 'G65', value: 'Litro por día kelvin' },
  { key: 'G66', value: 'Litro por hora kelvin' },
  { key: 'G67', value: 'Litro por minuto kelvin' },
  { key: 'G68', value: 'Litro por segundo kelvin' },
  { key: 'G69', value: 'Metro cúbico por día kelvin' },
  { key: 'G7', value: 'Hoja de microficha' },
  { key: 'G70', value: 'Metro cúbico por hora kelvin' },
  { key: 'G71', value: 'Metro cúbico por minuto kelvin' },
  { key: 'G72', value: 'Metro cúbico por segundo kelvin' },
  { key: 'G73', value: 'Mililitro por día kelvin' },
  { key: 'G74', value: 'Mililitro por hora kelvin' },
  { key: 'G75', value: 'Mililitro por minuto kelvin' },
  { key: 'G76', value: 'Mililitro por segundo kelvin' },
  { key: 'G77', value: 'Milímetro a la cuarta potencia ' },
  { key: 'G78', value: 'Centímetro cúbico por día bar' },
  { key: 'G79', value: 'Centímetro cúbico por hora bar' },
  { key: 'G80', value: 'Centímetro cúbico por minuto bar' },
  { key: 'G81', value: 'Centímetro cúbico por segundo bar' },
  { key: 'G82', value: 'Litro por día bar' },
  { key: 'G83', value: 'Litro por hora bar' },
  { key: 'G84', value: 'Litro por minuto bar' },
  { key: 'G85', value: 'Litro por segundo bar' },
  { key: 'G86', value: 'Metro cúbico por día bar' },
  { key: 'G87', value: 'Metro cúbico por hora bar' },
  { key: 'G88', value: 'Metro cúbico por minuto bar' },
  { key: 'G89', value: 'Metro cúbico por segundo bar' },
  { key: 'G90', value: 'Mililitro por día bar' },
  { key: 'G91', value: 'Mililitro por hora bar' },
  { key: 'G92', value: 'Mililitro por minuto bar' },
  { key: 'G93', value: 'Mililitro por segundo bar' },
  { key: 'G94', value: 'Centímetro cúbico por bar' },
  { key: 'G95', value: 'Litro por bar' },
  { key: 'G96', value: 'Metro cúbico por bar' },
  { key: 'G97', value: 'Mililitro por bar ' },
  { key: 'G98', value: 'Micro henry por kiloOhm' },
  { key: 'G99', value: 'Micro henry por Ohm' },
  { key: 'GB', value: 'Galón (EUA) por día' },
  { key: 'GBQ', value: 'Gigabecquerel' },
  { key: 'GC', value: 'Gramo por 100 gramos' },
  { key: 'Gd', value: 'Barril bruto' },
  { key: 'GDW', value: 'Gramo, peso seco' },
  { key: 'GE', value: 'Libra por galón (EUA)' },
  { key: 'GF', value: 'Gramo por metro (gramo por 100 centímetros)' },
  { key: 'GFI', value: 'Gramo de isótopo fisible' },
  { key: 'GGR', value: 'Grandioso' },
  { key: 'GH', value: 'Medio galón (US)' },
  { key: 'GIA', value: 'Gill (us)' },
  { key: 'GIC', value: 'Gramo, incluido el contenedor' },
  { key: 'GII', value: 'Gill (uk)' },
  { key: 'GIP', value: 'Grama, incluido el embalaje interior' },
  { key: 'GJ', value: 'Gramo por mililitro' },
  { key: 'GK', value: 'Gramo por kilogramo' },
  { key: 'GL', value: 'Gramo por litro' },
  { key: 'GLD', value: 'Galón seco (EUA)' },
  { key: 'GLI', value: 'Galón (UK)' },
  { key: 'GLL', value: 'Galón (EUA)' },
  { key: 'GM', value: 'Gramo por metro cuadrado' },
  { key: 'GN', value: 'Galón bruto' },
  { key: 'GO', value: 'Miligramo por metro cuadrado' },
  { key: 'GP', value: 'Miligramo por metro cúbico' },
  { key: 'GQ', value: 'Microgramo por metro cúbico' },
  { key: 'GRM', value: 'Gramo' },
  { key: 'GRN', value: 'Grano' },
  { key: 'GRO', value: 'Gross' },
  { key: 'GT', value: 'Tonelada bruta' },
  { key: 'GV', value: 'Gigajoule' },
  { key: 'GW', value: 'Galón por mil pies cúbicos' },
  { key: 'GWH', value: 'Gigawatt hora' },
  { key: 'GY', value: 'Patio grueso' },
  { key: 'GZ', value: 'Sistema de calibración' },
  { key: 'H03', value: 'Henry por kiloOhm' },
  { key: 'H04', value: 'Henry por Ohm' },
  { key: 'H05', value: 'Milihenry por kiloOhm' },
  { key: 'H06', value: 'Milihenry por Ohm' },
  { key: 'H07', value: 'Pascal segundo por bar' },
  { key: 'H08', value: 'Microbequerel' },
  { key: 'H09', value: 'Año recíproco' },
  { key: 'H1', value: 'Media página - electrónica' },
  { key: 'H10', value: 'Hora recíproca' },
  { key: 'H11', value: 'Mes recíproco' },
  { key: 'H12', value: 'Grado celsius por hora' },
  { key: 'H13', value: 'Grado celsius por minuto' },
  { key: 'H14', value: 'Grado celsius por segundo' },
  { key: 'H15', value: 'Centímetro cudrado por gramo' },
  { key: 'H16', value: 'Decámetro cuadrado' },
  { key: 'H18', value: 'Hectómetro cuadrado' },
  { key: 'H19', value: 'Hectómetro cúbico' },
  { key: 'H2', value: 'Medio litro' },
  { key: 'H20', value: 'Kilómetro cúbico' },
  { key: 'H21', value: 'Blanco' },
  { key: 'H22', value: 'Voltio pulgada cuadrada por libra fuerza' },
  { key: 'H23', value: 'Voltio por pulgada' },
  { key: 'H24', value: 'Voltio por microsegundo' },
  { key: 'H25', value: 'Por ciento por kelvin' },
  { key: 'H26', value: 'Ohm por metro' },
  { key: 'H27', value: 'Grado por metro' },
  { key: 'H28', value: 'Microfaradio por kilómetro' },
  { key: 'H29', value: 'Microgramo por litro' },
  { key: 'H30', value: 'Micrómetro cuadrado' },
  { key: 'H31', value: 'Amperio por kilogramo' },
  { key: 'H32', value: 'Amperio cuadrado segundo' },
  { key: 'H33', value: 'Faradio por kilómetro' },
  { key: 'H34', value: 'Hertz metro' },
  { key: 'H35', value: 'Kelvin metro por watt' },
  { key: 'H36', value: 'MegaOhm por kilómetro' },
  { key: 'H37', value: 'MegaOhm por metro' },
  { key: 'H38', value: 'Megaamperio' },
  { key: 'H39', value: 'Megahertz kilómetro' },
  { key: 'H40', value: 'Newton por amperio' },
  { key: 'H41', value: 'Newton metro watts elevado a la potencia menos 0.5' },
  { key: 'H42', value: 'Pascal por metro' },
  { key: 'H43', value: 'Siemens por centímetro' },
  { key: 'H44', value: 'TeraOhm' },
  { key: 'H45', value: 'Voltio segundo por metro' },
  { key: 'H46', value: 'Voltio por segundo' },
  { key: 'H47', value: 'Watt por metro cúbico' },
  { key: 'H48', value: 'Attofarad' },
  { key: 'H49', value: 'Centímetro por hora' },
  { key: 'H50', value: 'Reciprocidad del centimetro cúbico' },
  { key: 'H51', value: 'Decibel per kilometro' },
  { key: 'H52', value: 'Decibel per metro' },
  { key: 'H53', value: 'Kilogramo por bar' },
  { key: 'H54', value: 'Kilogramo por decímetro cúbico kelvin ' },
  { key: 'H55', value: 'Kilogramo por decímetro cúbico bar' },
  { key: 'H56', value: 'Kilogramo por metro cuadrado segundo' },
  { key: 'H57', value: 'Pulgada por dos pi por radián' },
  { key: 'H58', value: 'Metro por voltio segundo' },
  { key: 'H59', value: 'Metro cuadrado por newton' },
  { key: 'H60', value: 'Metro cúbico por metro cúbico' },
  { key: 'H61', value: 'Milisiemens por centímetro' },
  { key: 'H62', value: 'Milivoltio por minuto' },
  { key: 'H63', value: 'Miligramo por centímetro cuadrado' },
  { key: 'H64', value: 'Miligramo por gramo' },
  { key: 'H65', value: 'Mililitro por metro cúbico' },
  { key: 'H66', value: 'Milímetro por año ' },
  { key: 'H67', value: 'Milímetro por hora' },
  { key: 'H68', value: 'MiliMol por gram' },
  { key: 'H69', value: 'Picopascal por kilometro' },
  { key: 'H70', value: 'Picosegundo' },
  { key: 'H71', value: 'Por ciento al mes' },
  { key: 'H72', value: 'Por ciento por hectobar' },
  { key: 'H73', value: 'Por ciento por decakelvin' },
  { key: 'H74', value: 'Watt por metro' },
  { key: 'H75', value: 'Decapascal' },
  { key: 'H76', value: 'Gramo por milímetro' },
  { key: 'H77', value: 'Anchura del módulo' },
  { key: 'H78', value: 'Centímetro convencional de agua' },
  { key: 'H79', value: 'Escala francesa ' },
  { key: 'H80', value: 'Unidad de bastidor' },
  { key: 'H81', value: 'Milímetro por minuto' },
  { key: 'H82', value: 'Punto grande' },
  { key: 'H83', value: 'Litro por kilogramo' },
  { key: 'H84', value: 'Gramos milímetro' },
  { key: 'H85', value: 'Semana recíproca' },
  { key: 'H87', value: 'Pieza' },
  { key: 'H88', value: 'MegaOhm kilómetro' },
  { key: 'H89', value: 'Por ciento por Ohmio' },
  { key: 'H90', value: 'Porcentaje por grado' },
  { key: 'H91', value: 'Por ciento por cada diez mil' },
  { key: 'H92', value: 'Ciento por cien mil' },
  { key: 'H93', value: 'Porcentaje por cien' },
  { key: 'H94', value: 'Por ciento por mil' },
  { key: 'H95', value: 'Por ciento por voltio' },
  { key: 'H96', value: 'Tanto por ciento por bar' },
  { key: 'H98', value: 'Por ciento por pulgada' },
  { key: 'H99', value: 'Por ciento por metro' },
  { key: 'HA', value: 'Madeja' },
  { key: 'HAR', value: 'hectárea' },
  { key: 'HBA', value: 'Hectobar ' },
  { key: 'HBX', value: 'Ciento de cajas' },
  { key: 'HC', value: 'Conteo en cientos' },
  { key: 'HD', value: 'Media docena' },
  { key: 'HDW', value: 'Cien kilogramos, peso seco' },
  { key: 'HE', value: 'Centésima de un quilate' },
  { key: 'HEA', value: 'Cabeza' },
  { key: 'HF', value: 'Cien pies' },
  { key: 'HGM', value: 'Héctogramo' },
  { key: 'HH', value: 'Cien pies cúbicos' },
  { key: 'HI', value: 'Cien hojas' },
  { key: 'HIU', value: 'Unidad internacional de cien' },
  { key: 'HJ', value: 'Potencia métrica' },
  { key: 'HK', value: 'Cien kilogramos' },
  { key: 'HKM', value: 'Cien kilogramos, masa neta' },
  { key: 'HL', value: 'Cien pies (lineal)' },
  { key: 'HLT', value: 'Hectolitro' },
  { key: 'HM', value: 'Milla por hora (milla estatal)' },
  { key: 'HMQ', value: 'Millones de metros cúbicos' },
  { key: 'HMT', value: 'Hectómetro' },
  { key: 'HN', value: 'Milímetro convencional de mercurio' },
  { key: 'HO', value: 'Cien onzas troy' },
  { key: 'HP', value: 'Milímetro convencional de agua' },
  { key: 'HPA', value: 'Hectolitro de alcohol puro' },
  { key: 'HS', value: 'Cien pies cuadrados' },
  { key: 'HT', value: 'media hora' },
  { key: 'HTZ', value: 'Hertz' },
  { key: 'HUR', value: 'Hora' },
  { key: 'HY', value: 'Cien yardas' },
  { key: 'IA', value: 'Pulgada libra' },
  { key: 'IC', value: 'Contar por pulgada' },
  { key: 'IE', value: 'Personas' },
  { key: 'IF', value: 'Pulgadas de agua' },
  { key: 'II', value: 'Columna pulgada' },
  { key: 'IM', value: 'Impresión' },
  { key: 'INH', value: 'Pulgada' },
  { key: 'INK', value: 'Pulgada cuadrada' },
  { key: 'INQ', value: 'Pulgada cúbica' },
  { key: 'IP', value: 'póliza de seguros' },
  { key: 'ISD', value: 'Grado internacional de azúcar' },
  { key: 'IT', value: 'Recuento por centímetro' },
  { key: 'IU', value: 'Pulgada por segundo' },
  { key: 'IV', value: 'Pulgada por segundo al cuadrado' },
  { key: 'J10', value: 'Por ciento por milímetro' },
  { key: 'J12', value: 'Por mille por psi' },
  { key: 'J13', value: 'Grado api' },
  { key: 'J14', value: 'Grado baume (escala de origen)' },
  { key: 'J15', value: 'Grado baume (us pesado)' },
  { key: 'J16', value: 'Grado baume (luz de los EUA)' },
  { key: 'J17', value: 'Grado balling' },
  { key: 'J18', value: 'Grado brix' },
  { key: 'J19', value: 'Grado fahrenheit hora pie cuadrado por unidad térmica británica (termoquímico).' },
  { key: 'J2', value: 'Joule por kilogramo' },
  { key: 'J20', value: 'Grado fahrenheit por kelvin' },
  { key: 'J21', value: 'Grado fahrenheit por bar' },
  { key: 'J22', value: 'Grado fahrenheit hora pie cuadrado por unidad térmica británica (tabla internacional).' },
  { key: 'J23', value: 'Grado fahrenheit por hora' },
  { key: 'J24', value: 'Grado fahrenheit por minuto' },
  { key: 'J25', value: 'Grado fahrenheit por segundo' },
  { key: 'J26', value: 'Reciprocidad grado fahrenheit' },
  { key: 'J27', value: 'Grado oechsle' },
  { key: 'J28', value: 'Grado rankine por hora' },
  { key: 'J29', value: 'Grado rankine por minuto' },
  { key: 'J30', value: 'Grado rankine por segundo' },
  { key: 'J31', value: 'Grado twaddel.' },
  { key: 'J32', value: 'Micropoise' },
  { key: 'J33', value: 'Microgramo por kilogramo' },
  { key: 'J34', value: 'Microgramo por metro cúbico kelvin' },
  { key: 'J35', value: 'Microgramo por metro cúbico bar' },
  { key: 'J36', value: 'Microlitro por litro' },
  { key: 'J38', value: 'Baud' },
  { key: 'J39', value: 'Unidad térmica británica (significado)' },
  { key: 'J40', value: 'Unidad térmica británica (tabla internacional) pie por hora pie cuadrado grado fahrenheit.' },
  { key: 'J41', value: 'Unidad térmica británica (tabla internacional) pulgada por hora pie cuadrado grado fahrenheit.' },
  { key: 'J42', value: 'Unidad térmica británica (tabla internacional) pulgada por segundo pie cuadrado grado fahrenheit.' },
  { key: 'J43', value: 'Unidad térmica británica (tabla internacional) por libra grado fahrenheit' },
  { key: 'J44', value: 'Unidad térmica británica (tabla internacional) por minuto' },
  { key: 'J45', value: 'Unidad térmica británica (tabla internacional) por segundo' },
  { key: 'J46', value: 'Unidad térmica británica (termoquímico) pie por hora pie cuadrado grado fahrenheit.' },
  { key: 'J47', value: 'Unidad térmica británica (termoquímica) por hora' },
  { key: 'J48', value: 'Unidad térmica británica (termoquímico) pulgada por hora pie cuadrado grado fahrenheit.' },
  { key: 'J49', value: 'Unidad térmica británica (termoquímico) pulgada por segundo pie cuadrado grado fahrenheit.' },
  { key: 'J50', value: 'Unidad térmica británica (termoquímico) por libra grado fahrenheit' },
  { key: 'J51', value: 'Unidad térmica británica (termoquímica) por minuto' },
  { key: 'J52', value: 'Unidad térmica británica (termoquímica) por segundo' },
  { key: 'J53', value: 'Culombio metro cuadrado por kilogramo' },
  { key: 'J54', value: 'Megabaud' },
  { key: 'J55', value: 'Watt segundo' },
  { key: 'J56', value: 'Bar por bar' },
  { key: 'J57', value: 'Barril (uk petróleo)' },
  { key: 'J58', value: 'Barril (petróleo UK) por minuto' },
  { key: 'J59', value: 'Barril (petróleo UK) por día' },
  { key: 'J60', value: 'Barril (petróleo UK) por hora' },
  { key: 'J61', value: 'Barril (petróleo UK) por segundo' },
  { key: 'J62', value: 'Barril (petróleo estados unidos) por hora' },
  { key: 'J63', value: 'Barril (petróleo estados unidos) por segundo' },
  { key: 'J64', value: 'Bushel (UK) por día ' },
  { key: 'J65', value: 'Bushel (UK) por hora' },
  { key: 'J66', value: 'Bushel (UK) por minuto' },
  { key: 'J67', value: 'Bushel (UK) por segundo' },
  { key: 'J68', value: 'Bushel (seco,estados unidos) por día' },
  { key: 'J69', value: 'Bushel (seco,estados unidos) por hora' },
  { key: 'J70', value: 'Bushel (seco,estados unidos) por minuto' },
  { key: 'J71', value: 'Bushel (seco,estados unidos) por segundo' },
  { key: 'J72', value: 'Centinewton metro' },
  { key: 'J73', value: 'Centipoise por kelvin' },
  { key: 'J74', value: 'Centipoise por bar' },
  { key: 'J75', value: 'Caloría' },
  { key: 'J76', value: 'Caloría (tabla internacional) por gramo gadro celsius' },
  { key: 'J78', value: 'Caloría (termoquímica) por centímetro segundo grado celsius' },
  { key: 'J79', value: 'Caloría (termoquímico) por gramo gadro celsius' },
  { key: 'J81', value: 'Caloría (termoquímica) por minuto' },
  { key: 'J82', value: 'Caloría (termoquímica) por segundo' },
  { key: 'J83', value: 'Clo' },
  { key: 'J84', value: 'Centímetro por segundo kelvin' },
  { key: 'J85', value: 'Centímetro por segundo bar' },
  { key: 'J87', value: 'Centímetro cúbico por metro cúbico' },
  { key: 'J89', value: 'Centímetro de mercurio' },
  { key: 'J90', value: 'Decímetro cúbico por día' },
  { key: 'J91', value: 'Decímetro cúbico por metro cúbico' },
  { key: 'J92', value: 'Decímetro cúbico por minuto' },
  { key: 'J93', value: 'Decímetro cúbico por segundo' },
  { key: 'J94', value: 'Dina centímetro' },
  { key: 'J95', value: 'Onza (fluido, UK) por día' },
  { key: 'J96', value: 'Onza (fluido, UK) por hora' },
  { key: 'J97', value: 'Onza (fluido, UK) por minuto' },
  { key: 'J98', value: 'Onza (fluido, UK) por segundo' },
  { key: 'J99', value: 'Onza (fluido, estados unidos) por día' },
  { key: 'JB', value: 'Jumbo' },
  { key: 'JE', value: 'Joule por kelvin' },
  { key: 'JK', value: 'Megajoule por kilogramo' },
  { key: 'JM', value: 'Megajoule por metro cúbico' },
  { key: 'JNT', value: 'Junta de tubería' },
  { key: 'Jo', value: 'Articulación' },
  { key: 'JOU', value: 'Joule' },
  { key: 'JPS', value: 'Cien metros' },
  { key: 'JWL', value: 'Número de joyas' },
  { key: 'K1', value: 'Demanda de kilowatt' },
  { key: 'K10', value: 'Onza (fluido, estados unidos) por hora' },
  { key: 'K11', value: 'Onza (fluido, estados unidos) por minuto' },
  { key: 'K12', value: 'Onza (fluido, estados unidos) por segundo' },
  { key: 'K13', value: 'Pie por grado fahrenheit' },
  { key: 'K14', value: 'Pie por hora' },
  { key: 'K15', value: 'Pie libra-fuerza por hora' },
  { key: 'K16', value: 'Pie libra-fuerza por minuto' },
  { key: 'K17', value: 'Pie por psi (libra por pulgada cuadrada)' },
  { key: 'K18', value: 'Pie por segundo grado fahrenheit' },
  { key: 'K19', value: 'Pie por segundo psi (libra por pulgada cuadrada)' },
  { key: 'K2', value: 'Kilovoltios amperios demanda reactiva' },
  { key: 'K20', value: 'Reciprocidad del pie cuadrado' },
  { key: 'K21', value: 'Pie cúbico por grado fahrenheit' },
  { key: 'K22', value: 'Pie cúbico por día' },
  { key: 'K23', value: 'Pie cúbico por psi (libra por pulgada cuadrada)' },
  { key: 'K24', value: 'Pie de agua' },
  { key: 'K25', value: 'Pie de mercurio' },
  { key: 'K26', value: 'Galón (UK) por día' },
  { key: 'K27', value: 'Galón (UK) por hora' },
  { key: 'K28', value: 'Galón (UK) por segundo' },
  { key: 'K3', value: 'Kilovoltio amperio hora reactivo' },
  { key: 'K30', value: 'Galón (líquido, EUA) por segundo' },
  { key: 'K31', value: 'Gramo-fuerza por centímetro cuadrado' },
  { key: 'K32', value: 'Gill (UK) por día' },
  { key: 'K33', value: 'Gill (UK) por hora' },
  { key: 'K34', value: 'Gill (UK) por minuto' },
  { key: 'K35', value: 'Gill (UK) por segundo' },
  { key: 'K36', value: 'Gill (estados unidos) por día' },
  { key: 'K37', value: 'Gill (estados unidos) por hora' },
  { key: 'K38', value: 'Gill (estados unidos) por minuto' },
  { key: 'K39', value: 'Gill (estados unidos) por segundo' },
  { key: 'K40', value: 'Aceleración estándar de la caída libre' },
  { key: 'K41', value: 'Grano por galón (EUA)' },
  { key: 'K42', value: 'Caballo de fuerza de caldera ' },
  { key: 'K43', value: 'Caballo de fuerza (eléctrico)' },
  { key: 'K45', value: 'Pulgada por grado fahrenheit' },
  { key: 'K46', value: 'Pulgada por psi (libra por pulgada cuadrada)' },
  { key: 'K47', value: 'Pulgada por segundo grado fahrenheit' },
  { key: 'K48', value: 'Pulgada por segundo psi (libra por pulgada cuadrada)' },
  { key: 'K49', value: 'Reciprocidad de la pulgada cuadrada' },
  { key: 'K5', value: 'Kilovoltios amperios (reactivos)' },
  { key: 'K50', value: 'Kilobaud' },
  { key: 'K51', value: 'Kilocaloría (significado)' },
  { key: 'K52', value: 'Kilocaloría (tabla internacional) por hora metro grado celsius' },
  { key: 'K53', value: 'Kilocaloría (termoquímico)' },
  { key: 'K54', value: 'Kilocaloría (termoquímica) por minuto' },
  { key: 'K55', value: 'Kilocaloría (termoquímica) por segundo' },
  { key: 'K58', value: 'KiloMol por hora' },
  { key: 'K59', value: 'KiloMol por metro cúbico kelvin' },
  { key: 'K6', value: 'Kilolitro' },
  { key: 'K60', value: 'KiloMol por metro cúbico bar' },
  { key: 'K61', value: 'KiloMol por minuto' },
  { key: 'K62', value: 'Litro por litro' },
  { key: 'K63', value: 'Reciprocidad del litro' },
  { key: 'K64', value: 'Libra (avoirdupois) por grado fahrenheit' },
  { key: 'K65', value: 'Libra (avoirdupois) pie cuadrado' },
  { key: 'K66', value: 'Libra (avoirdupois) por día' },
  { key: 'K67', value: 'Libra por pie hora' },
  { key: 'K68', value: 'Libra por pie segundo' },
  { key: 'K69', value: 'Libra (avoirdupois) por pie cúbico grado fahrenheit' },
  { key: 'K70', value: 'Libra (avoirdupois) por pie cúbico psi' },
  { key: 'K71', value: 'Libra (avoirdupois) por galón (UK)' },
  { key: 'K73', value: 'Libra (avoirdupois) por hora grados fahrenheit' },
  { key: 'K74', value: 'Libra (avoirdupois) por hora libra-fuerza por pulgada cuadrada' },
  { key: 'K75', value: 'Libra (avoirdupois) por pulgada cúbica grado fahrenheit' },
  { key: 'K76', value: 'Libra (avoirdupois) por pulgada cúbica psi' },
  { key: 'K77', value: 'Libra (avoirdupois) por psi' },
  { key: 'K78', value: 'Libra (avoirdupois) por minuto' },
  { key: 'K79', value: 'Libra (avoirdupois) por minuto grados fahrenheit' },
  { key: 'K80', value: 'Libra (avoirdupois) por minuto libra-fuerza por pulgada cuadrada' },
  { key: 'K81', value: 'Libra (avoirdupois) por segundo' },
  { key: 'K82', value: 'Libra (avoirdupois)por segundo grados fahrenheit' },
  { key: 'K83', value: 'Libra (avoirdupois) por segundo libra-fuerza por pulgada cuadrada' },
  { key: 'K84', value: 'Libra por yarda cúbica ' },
  { key: 'K85', value: 'Libra-fuerza por pie cuadrado' },
  { key: 'K86', value: 'Libra-fuerza por pulgada cuadrada grados fahrenheit' },
  { key: 'K87', value: 'Libra-fuerza por pulgada cuadrada pulgada cúbica por segundo' },
  { key: 'K88', value: 'Libra-fuerza por pulgada cuadrada litro por segundo' },
  { key: 'K89', value: 'Libra-fuerza por pulgada cuadrada metro cúbico por segundo' },
  { key: 'K90', value: 'Libra-fuerza por pulgada cuadrada yarda cúbica por segundo' },
  { key: 'K91', value: 'Libra-fuerza segundo por pie cuadrado' },
  { key: 'K92', value: 'Libra-fuerza segundo por pulgada cuadrada' },
  { key: 'K93', value: 'Reciprocidad psi' },
  { key: 'K94', value: 'Cuarto (líquido, UK) por día' },
  { key: 'K95', value: 'Cuarto (líquido, UK) por hora' },
  { key: 'K96', value: 'Cuarto (líquido, UK) por minuto' },
  { key: 'K97', value: 'Cuarto (líquido, UK) por segundo' },
  { key: 'K98', value: 'Cuarto (líquido, estados unidos) por día' },
  { key: 'K99', value: 'Cuarto (líquido, estados unidos) por hora' },
  { key: 'KA', value: 'Pastel' },
  { key: 'KAT', value: 'Katal' },
  { key: 'KB', value: 'Kilocaracter' },
  { key: 'KBA', value: 'Kilobar' },
  { key: 'KCC', value: 'Kilogramo de cloruro de colina' },
  { key: 'KD', value: 'Kilogram decimal' },
  { key: 'KDW', value: 'Kilogramo de peso neto drenado' },
  { key: 'KEL', value: 'Kelvin' },
  { key: 'KF', value: 'Kilopacket' },
  { key: 'KGM', value: 'Kilogramo' },
  { key: 'KGS', value: 'Kilogramo por segundo' },
  { key: 'KHY', value: 'Kilogramo de peróxido de hidrógeno' },
  { key: 'KHZ', value: 'Kilohertz' },
  { key: 'KI', value: 'Kilogramo por milímetro de ancho' },
  { key: 'KIC', value: 'Kilogramo, incluyendo el contenedor' },
  { key: 'KIP', value: 'Kilogramo, incluyendo el empaquetado interno' },
  { key: 'KJ', value: 'Kilosegmento' },
  { key: 'KJO', value: 'Kilojoule' },
  { key: 'KL', value: 'Kilogramo por metro' },
  { key: 'KLK', value: 'Porcentaje de material seco láctico' },
  { key: 'KLX', value: 'Kilolux' },
  { key: 'KMA', value: 'Kilogramo de metilamina' },
  { key: 'KMH', value: 'Kilómetro por hora' },
  { key: 'KMK', value: 'Kilómetro cuadrado' },
  { key: 'KMQ', value: 'Kilogramo por metro cúbico' },
  { key: 'KMT', value: 'Kilómetro' },
  { key: 'KNI', value: 'Kilogramo de nitrógeno' },
  { key: 'KNM', value: 'Kolonewton por metro cuadrado' },
  { key: 'KNS', value: 'Kilogram sustancia nombrada' },
  { key: 'KNT', value: 'Nudo' },
  { key: 'KO', value: 'Miliequivalentes de potasa cáustica por gramo de producto' },
  { key: 'KPA', value: 'Kilopascal' },
  { key: 'KPH', value: 'Kilogramo de hidróxido de potasio (potasa cáustica)' },
  { key: 'KPO', value: 'Kilogramo de óxido de potasio' },
  { key: 'KPP', value: 'Kilogramo de pentóxido de fósforo (anhídrido fosfórico)' },
  { key: 'KR', value: 'Kiloroentgen' },
  { key: 'KS', value: 'Mil libras por pulgada cuadrada' },
  { key: 'KSD', value: 'Kilogramo de sustancia 90% seco' },
  { key: 'KSH', value: 'Kilogramo de hidróxido de sodio (sodio cáustica)' },
  { key: 'KT', value: 'Kit' },
  { key: 'KTN', value: 'Kilotonelada Métrica' },
  { key: 'KUR', value: 'Kilogramo de uranio' },
  { key: 'KVA', value: 'Kilovoltio - amperio' },
  { key: 'KVR', value: 'Kilovar' },
  { key: 'KVT', value: 'Kilovoltio' },
  { key: 'KW', value: 'Kilogramo por milímetro' },
  { key: 'KWH', value: 'Kilowatt hora' },
  { key: 'KWN', value: 'Kilowatt hora por metro cúbico normalizado' },
  { key: 'KWO', value: 'Kilogramo de trióxido de tungsteno' },
  { key: 'KWS', value: 'Kilowatt hora por metro cúbico estándar' },
  { key: 'KWT', value: 'Kilowatt' },
  { key: 'KX', value: 'Mililitro por kilogramo' },
  { key: 'L10', value: 'Cuarto (líquido, estados unidos) por minuto' },
  { key: 'L11', value: 'Cuarto (líquido, estados unidos) por segundo' },
  { key: 'L12', value: 'Metro por segundo kelvin' },
  { key: 'L13', value: 'Metro por segundo bar' },
  { key: 'L14', value: 'Metro cuadrado hora grado celsius por kilocaloría (tabla internacional)' },
  { key: 'L15', value: 'Milipascal segundo por kelvin' },
  { key: 'L16', value: 'Milipascal segundo por bar' },
  { key: 'L17', value: 'Miligramo por metro cúbico kelvin' },
  { key: 'L18', value: 'Miligramo por metro cúbico bar' },
  { key: 'L19', value: 'Mililitro por litro' },
  { key: 'L2', value: 'Litro por minuto' },
  { key: 'L20', value: 'Reciprocidad del milimetro cúbico' },
  { key: 'L21', value: 'Milimetro cúbico por metro cúbico' },
  { key: 'L23', value: 'Mol por hora ' },
  { key: 'L24', value: 'Mol por kilogramo kelvin' },
  { key: 'L25', value: 'Mol por kilogramo bar' },
  { key: 'L26', value: 'Mol por litreo kelvin' },
  { key: 'L27', value: 'Mol por litro bar' },
  { key: 'L28', value: 'Mol por metro cúbico kelvin' },
  { key: 'L29', value: 'Mol por metro cúbico bar' },
  { key: 'L30', value: 'Mol por minuto' },
  { key: 'L31', value: 'Milliroentgen aequivalent men' },
  { key: 'L32', value: 'Nanogramo por kilogramo' },
  { key: 'L33', value: 'Onza (avoirdupois) por día' },
  { key: 'L34', value: 'Onza (avoirdupois) por hora' },
  { key: 'L35', value: 'Onza (avoirdupois) por minuto' },
  { key: 'L36', value: 'Onza (avoirdupois) por segundo' },
  { key: 'L37', value: 'Onza (avoirdupois) por galón (UK)' },
  { key: 'L38', value: 'Onza (avoirdupois) por galón (EUA)' },
  { key: 'L39', value: 'Onza (avoirdupois) por pulgada cúbica' },
  { key: 'L40', value: 'Onza fuerza' },
  { key: 'L41', value: 'Onza (avoirdupois) fuerza pulgada' },
  { key: 'L42', value: 'Picosiemens por metro' },
  { key: 'L43', value: 'Peck (UK)' },
  { key: 'L44', value: 'Peck (UK) por día' },
  { key: 'L45', value: 'Peck (UK) por hora' },
  { key: 'L46', value: 'Peck (UK) por minuto' },
  { key: 'L47', value: 'Peck (UK) por segundo' },
  { key: 'L48', value: 'Peck (seco, estados unidos) por día' },
  { key: 'L49', value: 'Peck (seco, estados unidos) por hora' },
  { key: 'L50', value: 'Peck (seco, estados unidos) por minuto' },
  { key: 'L51', value: 'Peck (seco, estados unidos) por segundo' },
  { key: 'L52', value: 'Libra.fuerza por pulgada cuadrada por libra fuerza por pulgada cuadrada' },
  { key: 'L53', value: 'Pinta (UK) por día' },
  { key: 'L54', value: 'Pinta (UK) por hora' },
  { key: 'L55', value: 'Pinta (UK) por minuto' },
  { key: 'L56', value: 'Pinta (UK) por segundo' },
  { key: 'L57', value: 'Pinta (líquido, estados unidos) por día' },
  { key: 'L58', value: 'Pinta (líquido, estados unidos) por hora' },
  { key: 'L59', value: 'Pinta (líquido, estados unidos) por minuto' },
  { key: 'L60', value: 'Pinta (líquido, estados unidos) por segundo' },
  { key: 'L61', value: 'Pinta (US seco)' },
  { key: 'L62', value: 'Cuarto de galón (seco de los EUA)' },
  { key: 'L63', value: 'Slug por día' },
  { key: 'L64', value: 'Slug por pie segundo' },
  { key: 'L65', value: 'Slug por pie cúbico' },
  { key: 'L66', value: 'Slug por hora' },
  { key: 'L67', value: 'Slug por minuto' },
  { key: 'L68', value: 'Slug por segundo' },
  { key: 'L69', value: 'Tonelada por kelvin' },
  { key: 'L70', value: 'Tonelada por bar' },
  { key: 'L71', value: 'Tonelada por día' },
  { key: 'L72', value: 'Tonelada por día kelvin' },
  { key: 'L73', value: 'Tonelada por día bar' },
  { key: 'L74', value: 'Tonelada por hora kelvin' },
  { key: 'L75', value: 'Tonelada por hora bar' },
  { key: 'L76', value: 'Tonelada por metro cúbico kelvin' },
  { key: 'L77', value: 'Tonelada por metro cúbico bar' },
  { key: 'L78', value: 'Tonelada por minuto' },
  { key: 'L79', value: 'Tonelada por minuto kelvin' },
  { key: 'L80', value: 'Tonelada por minuto bar' },
  { key: 'L81', value: 'Tonelada por segundo' },
  { key: 'L82', value: 'Tonelada por segundo kelvin' },
  { key: 'L83', value: 'Tonelada por segundo bar' },
  { key: 'L84', value: 'Tonelada (flota UK)' },
  { key: 'L85', value: 'Tonelada larga por día' },
  { key: 'L86', value: 'Tonelada (flota estados unidos)' },
  { key: 'L87', value: 'Tonelada corta por grado fahrenheit' },
  { key: 'L88', value: 'Tonelada corta por día' },
  { key: 'L89', value: 'Tonelada corta por hora grados fahrenheit' },
  { key: 'L90', value: 'Tonelada corta por hora libra-fuerza por pulgada cuadrada' },
  { key: 'L91', value: 'Tonelada corta por psi' },
  { key: 'L92', value: 'Tonelada larga (UK) por yarda cúbica' },
  { key: 'L93', value: 'Tonelada corta (estados unidos) por yarda cúbica' },
  { key: 'L94', value: 'Tonelada fuerza' },
  { key: 'L95', value: 'Año común' },
  { key: 'L96', value: 'Año sideral' },
  { key: 'L98', value: 'Yarda por grado fahrenheit' },
  { key: 'L99', value: 'Yarda por psi (libra por pulgada cuadrada)' },
  { key: 'LA', value: 'Libra por pulgada cúbica ' },
  { key: 'LAC', value: 'Porcentaje de exceso de lactosa' },
  { key: 'LBR', value: 'Libra' },
  { key: 'LBT', value: 'Troy pound' },
  { key: 'LC', value: 'Centímetro lineal' },
  { key: 'LD', value: 'Litro por día' },
  { key: 'LE', value: 'Lite' },
  { key: 'LEF', value: 'Hoja' },
  { key: 'LF', value: 'Pie lineal' },
  { key: 'LH', value: 'Hora de trabajo' },
  { key: 'LI', value: 'Pulgada lineal' },
  { key: 'LJ', value: 'Spray grande' },
  { key: 'LK', value: 'Enlazar' },
  { key: 'LM', value: 'Metro lineal' },
  { key: 'LN', value: 'Longitud' },
  { key: 'LO', value: 'Lote [unidad de adquisición]' },
  { key: 'LP', value: 'Libra líquida' },
  { key: 'LPA', value: 'Litro de alcohol puro' },
  { key: 'LR', value: 'Capa ' },
  { key: 'LS', value: 'Suma global' },
  { key: 'LTN', value: 'Tonelada (UK) o tonelada larga (estados unidos)' },
  { key: 'LTR', value: 'Litro' },
  { key: 'LUB', value: 'Tonelada métrica, aceite lubricante' },
  { key: 'LUM', value: 'Lumen' },
  { key: 'LUX', value: 'Lux' },
  { key: 'LX', value: 'Yarda lineal por libra' },
  { key: 'LY', value: 'Yarda lineal' },
  { key: 'M0', value: 'cinta magnética' },
  { key: 'M1', value: 'Miligramo por litro' },
  { key: 'M10', value: 'Reciprocidad de la yarda cuadrada' },
  { key: 'M11', value: 'Yarda cúbica por grado fahrenheit' },
  { key: 'M12', value: 'Yarda cúbica por día' },
  { key: 'M13', value: 'Yarda cúbica por hora ' },
  { key: 'M14', value: 'Yarda cúbica por psi (libra por pulgada cuadrada)' },
  { key: 'M15', value: 'Yarda cúbica por minuto' },
  { key: 'M16', value: 'Yarda cúbica por segundo' },
  { key: 'M17', value: 'Kilohertz metro' },
  { key: 'M18', value: 'Gigahertz metro' },
  { key: 'M19', value: 'Beaufort' },
  { key: 'M20', value: 'Recíproco de megakelvin ó megakelvin a la potencia menos 1' },
  { key: 'M21', value: 'Kilovoltio-amperio hora recíprocidad' },
  { key: 'M22', value: 'Milímetro por centímetro cuadrado minuto' },
  { key: 'M23', value: 'Newton por centímetro' },
  { key: 'M24', value: 'Ohm kilómetro' },
  { key: 'M25', value: 'Porcentaje por grado celsius' },
  { key: 'M26', value: 'GigaOhm por metro' },
  { key: 'M27', value: 'Megahertz metro' },
  { key: 'M29', value: 'Kilogramo por kilogramo' },
  { key: 'M30', value: 'voltio-amperio segundo recíprocidad' },
  { key: 'M31', value: 'Kilogramo por kilómetro' },
  { key: 'M32', value: 'Segundos pascal por litro' },
  { key: 'M33', value: 'MiliMol por litro' },
  { key: 'M34', value: 'Newton metro por metro cuadrado' },
  { key: 'M35', value: 'Milivoltio - amperio' },
  { key: 'M36', value: 'Mes de 30 días' },
  { key: 'M37', value: 'Actual 360' },
  { key: 'M38', value: 'Kilómetro por segundo cuadrado' },
  { key: 'M39', value: 'Centímetro por segundo cuadrado' },
  { key: 'M4', value: 'Valor monetario' },
  { key: 'M40', value: 'Yarda por segundo cuadrado' },
  { key: 'M41', value: 'Milímetro por segundo cuadrado' },
  { key: 'M42', value: 'Milla (milla estatal)  por segundo cuadrado' },
  { key: 'M43', value: 'Mil (unidad de Medida Militar)' },
  { key: 'M44', value: 'Revolución' },
  { key: 'M45', value: 'Grado por segundo cuadrado' },
  { key: 'M46', value: 'Revolución por minuto' },
  { key: 'M47', value: 'Circular Mil' },
  { key: 'M48', value: 'Milla cuadrada (basado en u.s survey foot)' },
  { key: 'M49', value: 'Cadena ' },
  { key: 'M5', value: 'Microcurie' },
  { key: 'M50', value: 'Estadio' },
  { key: 'M51', value: 'Pie (Topografía UEA)' },
  { key: 'M52', value: 'Milla' },
  { key: 'M53', value: 'Metro por pascal' },
  { key: 'M55', value: 'Metro por radián' },
  { key: 'M56', value: 'Shake ' },
  { key: 'M57', value: 'Milla por minuto' },
  { key: 'M58', value: 'Milla por segundo' },
  { key: 'M59', value: 'Metro por segundo pascal' },
  { key: 'M60', value: 'Metro por hora' },
  { key: 'M61', value: 'Pulgada por año' },
  { key: 'M62', value: 'Kilómetro por segundo' },
  { key: 'M63', value: 'Pulgada por minuto' },
  { key: 'M64', value: 'Yarda por segundo' },
  { key: 'M65', value: 'Yarda por minuto' },
  { key: 'M66', value: 'Yarda por hora' },
  { key: 'M67', value: 'Acre-pie' },
  { key: 'M68', value: 'Cordón' },
  { key: 'M69', value: 'Milla cúbica (reinounido)' },
  { key: 'M7', value: 'Micro-pulgada' },
  { key: 'M70', value: 'Unidad tradicional de capacidad de carga' },
  { key: 'M71', value: 'Metro cúbico por pascal (joules)' },
  { key: 'M72', value: 'Bel' },
  { key: 'M73', value: 'Kilogramo por metro cúbico pascal' },
  { key: 'M74', value: 'Kilogramo por pascal' },
  { key: 'M75', value: 'Kilolibra fuerza' },
  { key: 'M76', value: 'Poundal' },
  { key: 'M77', value: 'Kilogramo metro por segundo cuadrado' },
  { key: 'M78', value: 'Pond' },
  { key: 'M79', value: 'Pie cuadrado por hora' },
  { key: 'M80', value: 'Stokes por pascal' },
  { key: 'M81', value: 'Centímetro cuadrado por segundo' },
  { key: 'M82', value: 'Metro cuadrado por segundo pascal' },
  { key: 'M83', value: 'Denier' },
  { key: 'M84', value: 'Libra por yarda ' },
  { key: 'M85', value: 'Tonelada, ensayo' },
  { key: 'M86', value: 'Libra Alemana' },
  { key: 'M87', value: 'Kilogramo por segundo pascal' },
  { key: 'M88', value: 'Tonelada por mes' },
  { key: 'M89', value: 'Tonelada por año' },
  { key: 'M9', value: 'Millones de btu por 1000 pies cúbicos' },
  { key: 'M90', value: 'Kilolibra por hora' },
  { key: 'M91', value: 'Libra por libra' },
  { key: 'M92', value: 'Libra fuerza pie' },
  { key: 'M93', value: 'Newton metro por radián' },
  { key: 'M94', value: 'Kilogramo metro' },
  { key: 'M95', value: 'Poundal pie' },
  { key: 'M96', value: 'Poundal pulgada' },
  { key: 'M97', value: 'Dina metro' },
  { key: 'M98', value: 'Kilogramo centímetro por segundo' },
  { key: 'M99', value: 'Gramo centímetro por segundo' },
  { key: 'MA', value: 'Máquina por unidad' },
  { key: 'MAH', value: 'Megavoltio amperio reactivo hora' },
  { key: 'MAL', value: 'Megalitro' },
  { key: 'MAM', value: 'Megametro' },
  { key: 'MAR', value: 'Megavar' },
  { key: 'MAW', value: 'Megawatt' },
  { key: 'MBE', value: 'Mil equivalente de ladrillo estándar' },
  { key: 'MBF', value: 'Mil pies de tabla' },
  { key: 'MBR', value: 'Milibar' },
  { key: 'MC', value: 'Microgramo' },
  { key: 'MCU', value: 'Milicurie' },
  { key: 'MD', value: 'Tonelada métrica seca al aire' },
  { key: 'MF', value: 'Miligramo por pie cuadrado por lado' },
  { key: 'MGM', value: 'Miligramo' },
  { key: 'MHZ', value: 'Megahertz' },
  { key: 'MIK', value: 'Milla cuadrada (milla estatal)' },
  { key: 'MIL', value: 'Mil' },
  { key: 'MIN', value: 'Minuto [unidad de tiempo]' },
  { key: 'MIO', value: 'Millon' },
  { key: 'MIU', value: 'Unidad internacional de millon' },
  { key: 'MK', value: 'Miligramo por pulgada cuadrada' },
  { key: 'MLD', value: 'Mil millones' },
  { key: 'MLT', value: 'Mililitro' },
  { key: 'MMK', value: 'Milímetro cuadrado' },
  { key: 'MMQ', value: 'Milímetro cúbico' },
  { key: 'MMT', value: 'Milímetro' },
  { key: 'MND', value: 'Kilogramo, peso seco' },
  { key: 'MON', value: 'Mes ' },
  { key: 'MPA', value: 'Megapascal' },
  { key: 'MQ', value: 'Mil metros' },
  { key: 'MQH', value: 'Metro cúbico por hora' },
  { key: 'MQS', value: 'Metro cúbico por segundo' },
  { key: 'MSK', value: 'Metro por segundo cuadrado' },
  { key: 'MTK', value: 'Metro cuadrado' },
  { key: 'MTQ', value: 'Metro cúbico' },
  { key: 'MTR', value: 'Metro' },
  { key: 'MTS', value: 'Metro por segundo' },
  { key: 'MV', value: 'Número de mults' },
  { key: 'MVA', value: 'Megavoltio - amperio' },
  { key: 'MWH', value: 'Megawatt hora' },
  { key: 'N1', value: 'Pluma calórica' },
  { key: 'N10', value: 'Libra pie por segundo' },
  { key: 'N11', value: 'Libra pulgada por segundo' },
  { key: 'N12', value: 'Pferdestaerke' },
  { key: 'N13', value: 'Centímetro de mercurio (0°)' },
  { key: 'N14', value: 'Centímetro de agua (4°)' },
  { key: 'N15', value: 'Pie de agua (39.2 °f)' },
  { key: 'N16', value: 'Pulgada de mercurio (32 °f)' },
  { key: 'N17', value: 'Pulgada de mercurio (60 °f)' },
  { key: 'N18', value: 'Pulgada de agua (39.2 °f)' },
  { key: 'N19', value: 'Pulgada de agua (60 °f)' },
  { key: 'N2', value: 'número de líneas' },
  { key: 'N20', value: 'Kip por pulgada cuadrada' },
  { key: 'N21', value: 'Poundal por pie cuadrado' },
  { key: 'N22', value: 'Onza (avoirdupois) por pulgada cuadrada' },
  { key: 'N23', value: 'Metro convencional de agua' },
  { key: 'N24', value: 'Gramo por milímetro cuadrado' },
  { key: 'N25', value: 'Libra por yarda cuadrada' },
  { key: 'N26', value: 'Poundal por pulgada cuadrada' },
  { key: 'N27', value: 'Pie a la cuarta potencia ' },
  { key: 'N28', value: 'Decímetro cúbico por kilogramo' },
  { key: 'N29', value: 'Pie cúbico por libra ' },
  { key: 'N3', value: 'Impresión de punto' },
  { key: 'N30', value: 'Pulgada cúbica por libra' },
  { key: 'N31', value: 'Kilonewton por metro' },
  { key: 'N32', value: 'Poundal por pulgada' },
  { key: 'N33', value: 'Libra-fuerza por yarda' },
  { key: 'N34', value: 'Poundal segundo por pie cuadrado' },
  { key: 'N35', value: 'Poise por pascal' },
  { key: 'N36', value: 'Newton segundo por metro cuadrado' },
  { key: 'N37', value: 'Kilogramo por metro segundo' },
  { key: 'N38', value: 'Kilogramo por metro minuto' },
  { key: 'N39', value: 'Kilogramo por metro día' },
  { key: 'N40', value: 'Kilogramo por metro hora' },
  { key: 'N41', value: 'Gramo por centímetro segundo' },
  { key: 'N42', value: 'Poundal segundo por pulgada cuadrada' },
  { key: 'N43', value: 'Libra por pie minuto' },
  { key: 'N44', value: 'Libra por pie día' },
  { key: 'N45', value: 'Metro cúbico por segundo pascal' },
  { key: 'N46', value: 'Pie poundal' },
  { key: 'N47', value: 'Pulgada poundal' },
  { key: 'N48', value: 'Watt por centímetro cuadrado' },
  { key: 'N49', value: 'Watt por pulgada cuadrada' },
  { key: 'N50', value: 'Unidad térmica británica (tabla internacional) por pie cuadrado hora.' },
  { key: 'N51', value: 'Unidad térmica británica (termoquímica) por pie cuadrado hora.' },
  { key: 'N52', value: 'Unidad térmica británica (termoquímico) por pie cuadrado minuto.' },
  { key: 'N53', value: 'Unidad térmica británica (tabla internacional) por pie cuadrado segundo.' },
  { key: 'N54', value: 'Unidad térmica británica (termoquímica) por pie cuadrado segundo.' },
  { key: 'N55', value: 'Unidad térmica británica (tabla internacional) por pulgada cuadrada segundo.' },
  { key: 'N56', value: 'Caloría (termoquímica) por centímetro cuadrado minuto' },
  { key: 'N57', value: 'Caloría (termoquímica) por centímetro cuadrado segundo' },
  { key: 'N58', value: 'Unidad térmica británica (tabla internacional) por pie cúbico' },
  { key: 'N59', value: 'Unidad térmica británica (termoquímica) por pie cúbico' },
  { key: 'N60', value: 'Unidad térmica británica (tabla internacional) por grado fahrenheit' },
  { key: 'N61', value: 'Unidad térmica británica (termoquímico) por grado fahrenheit' },
  { key: 'N62', value: 'Unidad térmica británica (tabla internacional) por grado rankine' },
  { key: 'N63', value: 'Unidad térmica británica (termoquímico) por grado rankine' },
  { key: 'N64', value: 'Unidad térmica británica (termoquímico) por libra grado rankine' },
  { key: 'N65', value: 'Kilocaloría (tabla internacional) por gramo kelvin' },
  { key: 'N66', value: 'Unidad térmica británica (39 °f)' },
  { key: 'N67', value: 'Unidad térmica británica (59 °f)' },
  { key: 'N68', value: 'Unidad térmica británica (60 °f)' },
  { key: 'N69', value: 'Caloría (20 °c)' },
  { key: 'N70', value: 'Quad' },
  { key: 'N71', value: 'Termia (energía comercial)' },
  { key: 'N72', value: 'Termia (UEA)' },
  { key: 'N73', value: 'Unidad térmica británica (termoquímica) por libra' },
  { key: 'N74', value: 'Unidad térmica británica (tabla internacional) por hora pie cuadrado grado fahrenheit.' },
  { key: 'N75', value: 'Unidad térmica británica (termoquímico) por hora pie cuadrado grado farenheit.' },
  { key: 'N76', value: 'Unidad térmica británica (tabla internacional) por segundo pie cuadrado grado fahrenheit.' },
  { key: 'N77', value: 'Unidad térmica británica (termoquímico) por segundo pie cuadrado grado fahrenheit.' },
  { key: 'N78', value: 'Kilowatt por metro cuadrado kelvin' },
  { key: 'N79', value: 'Kelvin por pascal' },
  { key: 'N80', value: 'Watt por metro grado celsius' },
  { key: 'N81', value: 'Kilowatt por metro kelvin' },
  { key: 'N82', value: 'Kilowatt por metro grado celsius' },
  { key: 'N83', value: 'Metro por grado celsius metro' },
  { key: 'N84', value: 'Grado fahrenheit hora por unidad térmica británica (tabla internacional)' },
  { key: 'N85', value: 'Grado fahrenheit hora por unidad térmica británica (termoquímico)' },
  { key: 'N86', value: 'Grado fahrenheit segundo por unidad térmica británica (tabla internacional)' },
  { key: 'N87', value: 'Grago fahrenheit segundo por unidad térmica británica (termoquímico)' },
  { key: 'N88', value: 'Grado fahrenheit hora pie cuadrado por unidad térmica británica (tabla internacional) pulgada' },
  { key: 'N89', value: 'Grado fahrenheit hora pie cuadrado por unidad térmica británica (termoquímico) pulgada.' },
  { key: 'N90', value: 'Kilofaradio' },
  { key: 'N91', value: 'Joule recíproco' },
  { key: 'N92', value: 'Picosiemens' },
  { key: 'N93', value: 'Amperio por pascal' },
  { key: 'N94', value: 'Franklin' },
  { key: 'N95', value: 'Amperio minuto' },
  { key: 'N96', value: 'Biot' },
  { key: 'N97', value: 'Gilbert' },
  { key: 'N98', value: 'Voltio por pascal' },
  { key: 'N99', value: 'Picovoltio' },
  { key: 'NA', value: 'Miligramo por kilogramo' },
  { key: 'NAR', value: 'Número de artículos' },
  { key: 'NB', value: 'barcaza' },
  { key: 'NBB', value: 'Número de bobinas' },
  { key: 'NC', value: 'Carro' },
  { key: 'NCL', value: 'Número de celulas' },
  { key: 'ND', value: 'Barril neto' },
  { key: 'NE', value: 'Litro neto' },
  { key: 'NEW', value: 'Newton' },
  { key: 'NF', value: 'Mensaje' },
  { key: 'NG', value: 'Galón neto (us)' },
  { key: 'NH', value: 'Hora del mensaje' },
  { key: 'NI', value: 'Galón imperial neto' },
  { key: 'NIL', value: 'Nil' },
  { key: 'NIU', value: 'Número de unidades internacionales' },
  { key: 'NJ', value: 'Número de pantallas' },
  { key: 'NL', value: 'Carga' },
  { key: 'NM3', value: 'Metro cúbico normalizado' },
  { key: 'NMI', value: 'Milla náutica' },
  { key: 'NMP', value: 'Número de paquetes' },
  { key: 'NN', value: 'tren' },
  { key: 'NPR', value: 'Número de parejas' },
  { key: 'NPT', value: 'Número de partes' },
  { key: 'NQ', value: 'Mho' },
  { key: 'NR', value: 'Micromho' },
  { key: 'NT', value: 'Tonelada neta' },
  { key: 'NTT', value: 'Tonelada de registro neto' },
  { key: 'NV', value: 'vehículo' },
  { key: 'NY', value: 'Libra por tonelada métrica al aire seco' },
  { key: 'NX', value: 'Parte por mil' },
  { key: 'OA', value: 'Panel' },
  { key: 'ODE', value: 'Equvalente de agotamiento del ozona' },
  { key: 'Ohm', value: 'Ohm' },
  { key: 'ON', value: 'Onza por yarda cuadrada' },
  { key: 'ONZ', value: 'Onza (avoirdupois)' },
  { key: 'OP', value: 'Dos paquetes' },
  { key: 'OPM', value: 'Oscilaciones por minuto' },
  { key: 'OT', value: 'Hora extra' },
  { key: 'OZ', value: 'Onza AV' },
  { key: 'OZA', value: 'Onza líquida (estados unidos)' },
  { key: 'OZI', value: 'Onza líquida (UK)' },
  { key: 'P0', value: 'Página electrónica' },
  { key: 'P1', value: 'Tanto por ciento' },
  { key: 'P10', value: 'Culombio por metro' },
  { key: 'P11', value: 'Kiloweber' },
  { key: 'P12', value: 'Gamma' },
  { key: 'P13', value: 'Kilotesla' },
  { key: 'P14', value: 'Joule por segundo' },
  { key: 'P15', value: 'Joule por minuto' },
  { key: 'P16', value: 'Joule por hora' },
  { key: 'P17', value: 'Joule por día' },
  { key: 'P18', value: 'Kilojoule por segundo' },
  { key: 'P19', value: 'Kilojoule por minuto' },
  { key: 'P2', value: 'Libra por pie' },
  { key: 'P20', value: 'Kilojoule por hora' },
  { key: 'P21', value: 'Kilojoule por dia' },
  { key: 'P22', value: 'NanoOhm' },
  { key: 'P23', value: 'Ohm circular-mil por pie' },
  { key: 'P24', value: 'Kilohenry' },
  { key: 'P25', value: 'Lumen por pie cuadrado' },
  { key: 'P26', value: 'Foto' },
  { key: 'P27', value: 'Vela (medida)' },
  { key: 'P28', value: 'Candela por pulgada cuadrada' },
  { key: 'P29', value: 'Footlambert' },
  { key: 'P3', value: 'Tres paquetes' },
  { key: 'P30', value: 'Lambert' },
  { key: 'P31', value: 'Stilb ' },
  { key: 'P32', value: 'Candela por pie cuadrado' },
  { key: 'P33', value: 'Kilocandela' },
  { key: 'P34', value: 'Milicandela' },
  { key: 'P35', value: 'Hefner-kerze' },
  { key: 'P36', value: 'Candela internacional' },
  { key: 'P37', value: 'Unidad térmica británica (tabla internacional) por pie cuadrado' },
  { key: 'P38', value: 'Unidad térmica británica (termoquímica) por pie cuadrado' },
  { key: 'P39', value: 'Caloría (termoquímica) por centímetro cuadrado' },
  { key: 'P4', value: 'paquete de cuatro' },
  { key: 'P40', value: 'Langley' },
  { key: 'P41', value: 'Década (logaritmica)' },
  { key: 'P42', value: 'Pascal por segundo cuadrado' },
  { key: 'P43', value: 'Bel por metro' },
  { key: 'P44', value: 'Libra Mol' },
  { key: 'P45', value: 'Libra de Mol por segundo' },
  { key: 'P46', value: 'Libra Mol por minuto' },
  { key: 'P47', value: 'KiloMol por kilogramo' },
  { key: 'P48', value: 'Libra de Mol por libra' },
  { key: 'P49', value: 'Newton metro cuadrado por amperio' },
  { key: 'P5', value: 'Paquete de cinco' },
  { key: 'P50', value: 'Metro weber' },
  { key: 'P51', value: 'Mol por kilogramo pascal ' },
  { key: 'P52', value: 'Mol por metro cúbico pascal' },
  { key: 'P53', value: 'Unit por segundo' },
  { key: 'P54', value: 'MiliGray por segundo' },
  { key: 'P55', value: 'MicroGray por segundo' },
  { key: 'P56', value: 'NanoGray por segundo' },
  { key: 'P57', value: 'Gray por minuto' },
  { key: 'P58', value: 'MiliGray por minuto' },
  { key: 'P59', value: 'Microgray por minuto' },
  { key: 'P6', value: 'paquete de seis' },
  { key: 'P60', value: 'Nanogray por minuto' },
  { key: 'P61', value: 'Gray por hora' },
  { key: 'P62', value: 'MiliGray por hora' },
  { key: 'P63', value: 'Micro gray por hora' },
  { key: 'P64', value: 'Nanogray por hora' },
  { key: 'P65', value: 'Sievert por segundo' },
  { key: 'P66', value: 'MilliSievert por segundo' },
  { key: 'P67', value: 'MicroSievert por segundo' },
  { key: 'P68', value: 'NanoSievert por segundo' },
  { key: 'P69', value: 'Rem por segundo' },
  { key: 'P7', value: 'Paquete de siete' },
  { key: 'P70', value: 'Sievert por hora' },
  { key: 'P71', value: 'MilliSievert por hora' },
  { key: 'P72', value: 'Micro Sievert por hora' },
  { key: 'P73', value: 'NanoSievert por hora' },
  { key: 'P74', value: 'Sievert por minuto' },
  { key: 'P75', value: 'MilliSievert por minuto' },
  { key: 'P76', value: 'MicroSievert por minuto' },
  { key: 'P77', value: 'NanoSievert pominut ' },
  { key: 'P78', value: 'Reciprocidad por segundo' },
  { key: 'P79', value: 'Pascal metro cuadrado por kilogramo' },
  { key: 'P8', value: 'Paquete de ocho' },
  { key: 'P80', value: 'Milipascal por metro.' },
  { key: 'P81', value: 'Kilopascal por metro.' },
  { key: 'P82', value: 'Hectopascal por metro.' },
  { key: 'P83', value: 'Admosfera estandar por metro.' },
  { key: 'P84', value: 'Admosfera tecnica por metro.' },
  { key: 'P85', value: 'Torr por metro.' },
  { key: 'P86', value: 'Psi por pulgada' },
  { key: 'P87', value: 'Metro cúbico por segundo de metro cuadrado' },
  { key: 'P88', value: 'Rhe' },
  { key: 'P89', value: 'Libra por metro cúbico de pulgada' },
  { key: 'P9', value: 'Nueve paquetes' },
  { key: 'P90', value: 'Libra-fuerza por pulgada cuadrada' },
  { key: 'P91', value: 'Permanente (0°c)' },
  { key: 'P92', value: 'Permanente (23°c)' },
  { key: 'P93', value: 'Byte por segundo' },
  { key: 'P94', value: 'Kilobyte por segundo' },
  { key: 'P95', value: 'Megabite por segundo' },
  { key: 'P96', value: 'Recíproco de la unidad si deriva voltio' },
  { key: 'P97', value: 'Reciprocidad de Radian' },
  { key: 'P98', value: 'Pascal a la suma de potencia de los números estequimetricos' },
  { key: 'P99', value: 'Mols por metro cúbico a la suma de potencia de los números estequimetricos' },
  { key: 'PAL', value: 'Pascal' },
  { key: 'PB', value: 'Par de la pulgada' },
  { key: 'PD', value: 'Almohadilla' },
  { key: 'PE', value: 'Libra equivalente' },
  { key: 'PFL', value: 'Litro de prueba ' },
  { key: 'PGL', value: 'Galón de prueba' },
  { key: 'PI', value: 'Tono' },
  { key: 'PLA', value: 'Grado de platón ' },
  { key: 'PM', value: 'Porcentaje de libra' },
  { key: 'PO', value: 'Libra por pulgada' },
  { key: 'PQ', value: 'Página por pulgada' },
  { key: 'PR', value: 'Par' },
  { key: 'PS', value: 'Libra fuerza por pulgada cuadrada' },
  { key: 'PT', value: 'Pinta (US)' },
  { key: 'PTD', value: 'Pinta seca (estados unidos)' },
  { key: 'PTI', value: 'Pint (uk)' },
  { key: 'PTL', value: 'Pinta líquida (estados unidos)' },
  { key: 'PTN', value: 'Parte' },
  { key: 'PV', value: 'Media pinta (US)' },
  { key: 'PW', value: 'Libra por pulgada de ancho' },
  { key: 'PY', value: 'Pico seco (EUA)' },
  { key: 'PZ', value: 'Peck dry (UK)' },
  { key: 'Q10', value: 'Joule por tesla' },
  { key: 'Q11', value: 'Erlang' },
  { key: 'Q12', value: 'Octeto' },
  { key: 'Q13', value: 'Octeto por segundo' },
  { key: 'Q14', value: 'Shannon' },
  { key: 'Q15', value: 'Hartley' },
  { key: 'Q16', value: 'Unidad natural de información ' },
  { key: 'Q17', value: 'Shannon por segundo' },
  { key: 'Q18', value: 'Hartley por segundo ' },
  { key: 'Q19', value: 'Unidad natural de información por segundo ' },
  { key: 'Q20', value: 'Segundo por kilogramo' },
  { key: 'Q21', value: 'Watt metro cuadrado' },
  { key: 'Q22', value: 'Segundo por metro cúbicos de radianes ' },
  { key: 'Q23', value: 'Weber a la potencia menos uno' },
  { key: 'Q24', value: 'Reciprocidad de Pulgada' },
  { key: 'Q25', value: 'Dioptría' },
  { key: 'Q26', value: 'Uno por uno' },
  { key: 'Q27', value: 'Newtons metros por metro' },
  { key: 'Q28', value: 'Kilograma por metro cuadrado pascal segundo' },
  { key: 'Q29', value: 'Microgramo por hectogramo' },
  { key: 'Q3', value: 'Comida' },
  { key: 'Q30', value: 'Ph (potencial de hidrogeno)' },
  { key: 'Q31', value: 'Kilojoule por gramo' },
  { key: 'Q32', value: 'Femtolitro' },
  { key: 'Q33', value: 'Picolitro' },
  { key: 'Q34', value: 'Nanolitro' },
  { key: 'Q35', value: 'Megawatts por minuto' },
  { key: 'Q36', value: 'Metro cuadrado por metro cúbico' },
  { key: 'Q37', value: 'Metro cúbico estándar por día' },
  { key: 'Q38', value: 'Metro cúbico estándar por hora' },
  { key: 'Q39', value: 'Metro cúbico normalizado por día' },
  { key: 'Q40', value: 'Metro cúbico normalizado por hora' },
  { key: 'Q41', value: 'Joule por metro cúbico normalizado' },
  { key: 'Q42', value: 'Joule por metro cúbico estándar' },
  { key: 'QA', value: 'Página-fascimil' },
  { key: 'QAN', value: 'Cuarto (de un año)' },
  { key: 'QB', value: 'Página, copia impresa' },
  { key: 'QD', value: 'Cuarta docena' },
  { key: 'QH', value: 'Un cuarto de hora' },
  { key: 'QK', value: 'Cuarto de kilogramo' },
  { key: 'QR', value: 'Mano de papel' },
  { key: 'QT', value: 'Cuarto (EUA)' },
  { key: 'QTD', value: 'Cuarto seco (estados unidos)' },
  { key: 'QTI', value: 'Cuarto (UK)' },
  { key: 'QTL', value: 'Cuarto de líquido (estadis unidos)' },
  { key: 'QTR', value: 'Cuarto' },
  { key: 'R1', value: 'Pica' },
  { key: 'R9', value: 'Mil metros cúbicos ' },
  { key: 'RH', value: 'Hora de funcionamiento' },
  { key: 'RK', value: 'Medida métrica de rollo' },
  { key: 'RM', value: 'Resma' },
  { key: 'RN', value: 'Medida métrica de Hojas (resma)' },
  { key: 'ROM', value: 'Habitación' },
  { key: 'RP', value: 'Libra por resma' },
  { key: 'RPM', value: 'Revoluciones por minuto' },
  { key: 'RPS', value: 'Revoluciones por segundo' },
  { key: 'RS', value: 'Reiniciar' },
  { key: 'RT', value: 'Milla de toneladas de ingresos' },
  { key: 'RU', value: 'correr' },
  { key: 'S3', value: 'Pie cuadrado por segundo' },
  { key: 'S4', value: 'Metro cuadrado por segundo' },
  { key: 'S5', value: 'Sesenta cuartos de pulgada' },
  { key: 'S6', value: 'Sesión' },
  { key: 'S7', value: 'unidad de almacenamiento' },
  { key: 'S8', value: 'Unidad de publicidad estándar' },
  { key: 'SAN', value: 'Medio año' },
  { key: 'SCO', value: 'Puntuación' },
  { key: 'SCR', value: 'Escrúpulo' },
  { key: 'SD', value: 'Libra sólida' },
  { key: 'SE', value: 'Sección' },
  { key: 'SEC', value: 'Segundo [unidad de tiempo]' },
  { key: 'SET', value: 'Conjunto' },
  { key: 'SG', value: 'Segmento ' },
  { key: 'SHT', value: 'Tonelada de envíos' },
  { key: 'SIE', value: 'Siemens' },
  { key: 'SK', value: 'Camión cisterna con división' },
  { key: 'SM3', value: 'Metro cúbico estándar' },
  { key: 'SMI', value: 'Milla (milla estatal)' },
  { key: 'SN', value: 'Barra cuadrada' },
  { key: 'SQ', value: 'Cuadrado' },
  { key: 'SQR', value: 'Cuadrado y techado' },
  { key: 'SR', value: 'Tira' },
  { key: 'SS', value: 'Medida métrica de hoja' },
  { key: 'SST', value: 'Estandar corto (7200 partidos)' },
  { key: 'STC', value: 'Palo' },
  { key: 'STI', value: 'Estone (UK)' },
  { key: 'STK', value: 'Palo, cigarrillo' },
  { key: 'STL', value: 'Litro estándar' },
  { key: 'STN', value: 'Tonelada (estados unidos) o tonelada corta (UK y estados unidos)' },
  { key: 'STW', value: 'Paja' },
  { key: 'SW', value: 'Número de madejas' },
  { key: 'SX', value: 'Envío' },
  { key: 'SYR', value: 'Jeringuilla' },
  { key: 'T0', value: 'Linea de telecomunicaciones en servicio' },
  { key: 'T1', value: 'Mil libras' },
  { key: 'T3', value: 'Mil pedazos' },
  { key: 'T4', value: 'Bolsa de mil' },
  { key: 'T5', value: 'Mil envolturas' },
  { key: 'T6', value: 'Mil galones (US)' },
  { key: 'T7', value: 'Impresión de mil' },
  { key: 'T8', value: 'Mil pulgadas lineales' },
  { key: 'TA', value: 'Décimo de pie cúbico' },
  { key: 'TAB', value: 'Tonelada de registro bruto' },
  { key: 'TAH', value: 'Kiloamperio-hora (milamperio-hora)' },
  { key: 'TAN', value: 'Número de acido total' },
  { key: 'TC', value: 'Camión' },
  { key: 'TD', value: 'Termico' },
  { key: 'TE', value: 'Totalizador' },
  { key: 'TF', value: 'Diez yardas cuadradas' },
  { key: 'TI', value: 'Mil pulgadas cuadradas' },
  { key: 'TIC', value: 'Tonelada métrica, incluido el contenedor' },
  { key: 'TIP', value: 'Tonelada métrica, incluido el embalaje interior' },
  { key: 'TJ', value: 'Mil centímetros cuadrados' },
  { key: 'TKM', value: 'Tonelada kilometro' },
  { key: 'TL', value: 'Mil pies (lineal)' },
  { key: 'TMS', value: 'Kilogramo de carne importada, menos despojos' },
  { key: 'TNE', value: 'Tonelada (tonelada métrica)' },
  { key: 'TP', value: 'Paquete de diez' },
  { key: 'TPI', value: 'Dientes por pulgada' },
  { key: 'TPR', value: 'Decenas de pares' },
  { key: 'TQ', value: 'Mil pies' },
  { key: 'TQD', value: 'Mil metros cúbicos por día ' },
  { key: 'TR', value: 'Diez pies cuadrados' },
  { key: 'TRL', value: 'Trillones (eur)' },
  { key: 'Ts', value: 'Mil pies cuadrados' },
  { key: 'TSD', value: 'Tonelada de sustancia 90% seca' },
  { key: 'TSH', value: 'Tonelada de vapor por hora' },
  { key: 'TST', value: 'Decena de conjuntos' },
  { key: 'TT', value: 'Mil metros lineales' },
  { key: 'TTS', value: 'Decenas de millar de pegatinas' },
  { key: 'Tu', value: 'Contenedor externo' },
  { key: 'TV', value: 'Mil kilogramos' },
  { key: 'TW', value: 'Mil hojas' },
  { key: 'U1', value: 'Tratamiento ' },
  { key: 'U2', value: 'Número de tabletas' },
  { key: 'UA', value: 'Torr' },
  { key: 'UB', value: 'Linea de telecomunicaciones en servicio promedio ' },
  { key: 'UC', value: 'Puerto de telecomunicaciones ' },
  { key: 'UD', value: 'Décimo minuto' },
  { key: 'UE', value: 'Hora de décimo' },
  { key: 'UF', value: 'Uso por línea de telecomunicaciones promedio' },
  { key: 'UH', value: 'Diez mil yardas' },
  { key: 'UM', value: 'Millón de unidades' },
  { key: 'UN', value: 'Newton metro' },
  { key: 'VA', value: 'Voltio-amperio por kilogramo' },
  { key: 'VLT', value: 'Voltio' },
  { key: 'VP', value: 'Volumen porcentual ' },
  { key: 'VS', value: 'Visita' },
  { key: 'W2', value: 'Kilo húmedo ' },
  { key: 'W4', value: 'Dos semanas' },
  { key: 'WA', value: 'Watt por kilogramo ' },
  { key: 'WB', value: 'Libra húmeda' },
  { key: 'WCD', value: 'Cable' },
  { key: 'WE', value: 'Tonelada húmeda ' },
  { key: 'WEB', value: 'Weber' },
  { key: 'WEE', value: 'Semana' },
  { key: 'WG', value: 'Galón de vino' },
  { key: 'WH', value: 'Rueda' },
  { key: 'WHR', value: 'Watt hora' },
  { key: 'WI', value: 'Peso por pulgada cuadrada' },
  { key: 'WM', value: 'Mes de trabajo ' },
  { key: 'WR', value: 'Envolver' },
  { key: 'WSD', value: 'Estándar' },
  { key: 'WTT', value: 'Watt' },
  { key: 'WW', value: 'Mililitro de agua' },
  { key: 'X1', value: 'Cadena de gunter' },
  { key: 'X1A', value: 'Tambor de acero' },
  { key: 'X1B', value: 'Tambor de aluminio' },
  { key: 'X1D', value: 'Tambor contrachapado' },
  { key: 'X1F', value: 'Contenedor flexible' },
  { key: 'X1G', value: 'Tambor de fibra' },
  { key: 'X1w', value: 'Tambor de madera' },
  { key: 'X2C', value: 'Barril de madera' },
  { key: 'X3A', value: 'Bidón de acero' },
  { key: 'X3H', value: 'Bidón de plástico' },
  { key: 'X43', value: 'Bolsa de gran tamaño' },
  { key: 'X44', value: 'Bolsa de plastico' },
  { key: 'X4A', value: 'Caja de acero' },
  { key: 'X4B', value: 'Caja de aluminio' },
  { key: 'X4C', value: 'Caja de  madera natural' },
  { key: 'X4D', value: 'Caja de contrachapado' },
  { key: 'X4F', value: 'Caja de madera reconstituida' },
  { key: 'X4G', value: 'Caja de cartón' },
  { key: 'X4H', value: 'Caja de plástico' },
  { key: 'X5H', value: 'Bolsa de plástico tejido' },
  { key: 'X5L', value: 'Bolsa textil' },
  { key: 'X5M', value: 'Bolsa de papel' },
  { key: 'X6H', value: 'Recipiente de plástico, Contenedor compuesto.' },
  { key: 'X6P', value: 'Recipiente de vidrio, Contenedor compuesto.' },
  { key: 'X7A', value: 'Estuche para carro' },
  { key: 'X7B', value: 'Estuche de madera' },
  { key: 'X8A', value: 'Pallet de madera' },
  { key: 'X8B', value: 'Cajón de madera' },
  { key: 'X8C', value: 'Madera flejada' },
  { key: 'XAA', value: 'Contenedor intermedio  para gráneles de plástico rígido' },
  { key: 'XAB', value: 'Contenedor de fibra' },
  { key: 'XAC', value: 'Contenedor de papel' },
  { key: 'XAD', value: 'Contenedor de madera' },
  { key: 'XAE', value: 'Aerosol' },
  { key: 'XAF', value: 'Pallet modular con collares,  80cms * 60cms' },
  { key: 'XAG', value: 'Pallet o empaquetado' },
  { key: 'XAH', value: 'Pallet, 100cms X 110cms' },
  { key: 'XAI', value: 'Contenedor tipo concha' },
  { key: 'XAJ', value: 'Cono' },
  { key: 'XAL', value: 'Esféra' },
  { key: 'XAM', value: 'Ampolleta no protegida' },
  { key: 'XAP', value: 'Ampolleta protegida' },
  { key: 'XAT', value: 'Atomizador' },
  { key: 'XAV', value: 'Cápsula' },
  { key: 'XB4', value: 'Cinturón' },
  { key: 'XBA', value: 'Barril' },
  { key: 'XBB', value: 'Bobina' },
  { key: 'XBC', value: 'Cajón para botellas / Estante para botellas' },
  { key: 'XBD', value: 'Tablero' },
  { key: 'XBE', value: 'Flejado' },
  { key: 'XBF', value: 'Globo no protegido' },
  { key: 'XBG', value: 'Bolso' },
  { key: 'XBH', value: 'Manojo' },
  { key: 'XBI', value: 'Compartimiento' },
  { key: 'XBJ', value: 'Cubeta' },
  { key: 'XBK', value: 'Cesta' },
  { key: 'XBL', value: 'Paca comprimida' },
  { key: 'XBM', value: 'Cuenco' },
  { key: 'XBN', value: 'Paca no comprimida' },
  { key: 'XBO', value: 'Botella no-protegida y cilíndrica' },
  { key: 'XBP', value: 'Globo protegido' },
  { key: 'XBQ', value: 'Botella cilíndrica protegida' },
  { key: 'XBR', value: 'Barra' },
  { key: 'XBS', value: 'Botella, no-protegida en forma de bulbo' },
  { key: 'XBT', value: 'Rollo de tela' },
  { key: 'XBU', value: 'Butt' },
  { key: 'XBV', value: 'Botella de bulbo protegido' },
  { key: 'XBW', value: 'Caja para líquidos' },
  { key: 'XBX', value: 'Caja' },
  { key: 'XBY', value: 'Tablero, con fleje/ agrupados/ armados' },
  { key: 'XBZ', value: 'Barras, con fleje/ agrupados/ armados' },
  { key: 'XCA', value: 'Lata rectangular' },
  { key: 'XCB', value: 'Cajón para cerveza' },
  { key: 'XCC', value: 'Mantequera' },
  { key: 'XCD', value: 'Lata con mango y boquilla' },
  { key: 'XCE', value: 'Cesto tejido' },
  { key: 'XCF', value: 'Cofre' },
  { key: 'XCG', value: 'Contenedor tipo Jaula' },
  { key: 'XCH', value: 'Cajonera' },
  { key: 'XCI', value: 'Frasco' },
  { key: 'XCJ', value: 'Ataúd' },
  { key: 'XCK', value: 'Barrica' },
  { key: 'XCL', value: 'Espiral' },
  { key: 'XCM', value: 'Paquete de tarjetas' },
  { key: 'XCN', value: 'Contenedor, no especificado como equipo de transporte' },
  { key: 'XCO', value: 'Garrafón no protegido' },
  { key: 'XCP', value: 'Garrafón protegido' },
  { key: 'XCQ', value: 'Cartucho' },
  { key: 'XCR', value: 'Cajón' },
  { key: 'XCS', value: 'Estuche' },
  { key: 'XCT', value: 'Cartón' },
  { key: 'XCU', value: 'Vaso' },
  { key: 'XCV', value: 'Cubierta' },
  { key: 'XCW', value: 'Jaula estilo rodillo' },
  { key: 'XCX', value: 'Lata cilíndrica' },
  { key: 'XCY', value: 'Cilindro' },
  { key: 'XCZ', value: 'Lona' },
  { key: 'XDA', value: 'Cajón multicapa de plástico' },
  { key: 'XDB', value: 'Cajón de varias capas de madera' },
  { key: 'XDC', value: 'Cajón multicapa de cartón' },
  { key: 'XDG', value: 'Jaula, Según la clasificación de la compañía (Commonwealth Handling Equipment Pool (CHEP))' },
  { key: 'XDH', value: 'Caja, Según la clasificación de la compañía (CHEP), Eurobox' },
  { key: 'XDI', value: 'Tambor de hierro' },
  { key: 'XDJ', value: 'damajuana o garrafa, no protegido' },
  { key: 'XDK', value: 'Cajón a granel, cartón' },
  { key: 'XDL', value: 'Cajas de plástico' },
  { key: 'XDM', value: 'Cajones a granel de madera' },
  { key: 'XDN', value: 'Dispensador' },
  { key: 'XDP', value: 'damajuana o garrafa, protegido' },
  { key: 'XDR', value: 'Tambor' },
  { key: 'XDS', value: 'Bandeja de una capa sin cubierta y de plástico' },
  { key: 'XDT', value: 'Bandeja de una capa sin cubierta y de madera' },
  { key: 'XDU', value: 'Bandeja de una capa sin cubierta y  poliestireno' },
  { key: 'XDV', value: 'Bandeja de una capa sin cubierta y de cartón' },
  { key: 'XDW', value: 'Bandeja de dos capas sin tapa y con bandeja de plástico' },
  { key: 'XDX', value: 'Bandeja de dos capas sin cubierta y de madera' },
  { key: 'XDY', value: 'Bandeja de dos capas sin cubierta y de cartón' },
  { key: 'XEC', value: 'Bolsa de plástico' },
  { key: 'XED', value: 'Estuche, con pallet de base' },
  { key: 'XEE', value: 'Estuche, con pallet base de madera' },
  { key: 'XEF', value: 'Estuche, con pallet base de cartón' },
  { key: 'XEG', value: 'Estuche, con pallet base de plástico' },
  { key: 'XEH', value: 'Estuche, con pallet base de metal' },
  { key: 'XEI', value: 'Estuche isotérmico' },
  { key: 'XEN', value: 'Sobre' },
  { key: 'XFB', value: 'Bolsa flexible' },
  { key: 'XFC', value: 'Cajón para fruta' },
  { key: 'XFD', value: 'Cajón enmarcado' },
  { key: 'XFE', value: 'Tanque flexible' },
  { key: 'XFI', value: 'Firkin' },
  { key: 'XFL', value: 'Matraz' },
  { key: 'XFO', value: 'Cajón para zapatos' },
  { key: 'XFP', value: 'Caja auxiliar para película fotográfica' },
  { key: 'XFR', value: 'Marco' },
  { key: 'XFT', value: 'Contenedor para alimentos' },
  { key: 'XFW', value: 'Carro de cama plana' },
  { key: 'XFX', value: 'Bolsa flexible tipo contenedor' },
  { key: 'XGB', value: 'Botella para gas' },
  { key: 'XGI', value: 'Viga' },
  { key: 'XGL', value: 'Contenedor tipo galón' },
  { key: 'XGR', value: 'Recipiente de vidrio' },
  { key: 'XGU', value: 'Bandeja contenedor para apilar horizontalmente objetos planos' },
  { key: 'XGY', value: 'Costal de Yute' },
  { key: 'XGZ', value: 'Vigas con correas o agrupadas' },
  { key: 'XHA', value: 'Cesta con mango y de plástico' },
  { key: 'XHB', value: 'Cesta con mango y de madera' },
  { key: 'XHC', value: 'Cesta  con asa y de  cartón' },
  { key: 'XHG', value: 'Hogshead' },
  { key: 'XHN', value: 'Gancho' },
  { key: 'XHR', value: 'Cesto' },
  { key: 'XIA', value: 'Paquete con pantalla y de madera' },
  { key: 'XIB', value: 'Paquete  con pantalla y de cartón' },
  { key: 'XIC', value: 'Paquete con pantalla y de plástico' },
  { key: 'XID', value: 'Paquete con pantalla y de metal' },
  { key: 'XIE', value: 'Paquete de mostrador.' },
  { key: 'XIF', value: 'Envase para alimentos' },
  { key: 'XIG', value: 'Paquete envuelto en papel' },
  { key: 'XIH', value: 'Tambor de plástico' },
  { key: 'XIK', value: 'Paquete de cartón con los agujeros para botellas' },
  { key: 'XIL', value: 'Bandeja rígida con tapa y apilable (CEN TS 14482: 2002)' },
  { key: 'XIN', value: 'Lingote' },
  { key: 'XIZ', value: 'Lingotes  con correas/ agrupados' },
  { key: 'XJB', value: 'Bolsa jumbo' },
  { key: 'XJC', value: 'Bidón rectangular' },
  { key: 'XJG', value: 'Jarra' },
  { key: 'XJR', value: 'Tarro' },
  { key: 'XJT', value: 'Bolsa de yute' },
  { key: 'XJY', value: 'Bidón, cilíndrico' },
  { key: 'XKG', value: 'Barrilete' },
  { key: 'XKI', value: 'Kit (Conjunto de piezas)' },
  { key: 'XLE', value: 'Valijas' },
  { key: 'XLG', value: 'Bitacora' },
  { key: 'XLT', value: 'Lote' },
  { key: 'XLU', value: 'Caja de arrastre' },
  { key: 'XLV', value: 'Contenedor pequeño' },
  { key: 'XLZ', value: 'Registros  con fleje/ agrupados/ armados' },
  { key: 'XMA', value: 'Cajón metálico' },
  { key: 'XMB', value: 'Múltiplo de bolsas' },
  { key: 'XMC', value: 'Cajón para leche' },
  { key: 'XME', value: 'Contenedor de metal' },
  { key: 'XMR', value: 'Recipiente de metal' },
  { key: 'XMS', value: 'Saco milti-pared' },
  { key: 'XMT', value: 'Tapete' },
  { key: 'XMW', value: 'Contenedor envuelto en plástico' },
  { key: 'XMX', value: 'Caja pequeña de cerillos' },
  { key: 'XNA', value: 'No disponible' },
  { key: 'XNE', value: 'Sin empaque o no empaquetado' },
  { key: 'XNF', value: 'Sin empaque o no empaquetado, unidad simple' },
  { key: 'XNG', value: 'Sin empaque o no empaquetado, unidades múltiples' },
  { key: 'XNS', value: 'Caja nido' },
  { key: 'XNT', value: 'Red' },
  { key: 'XNU', value: 'Red de plástico con tubo' },
  { key: 'XNV', value: 'Red textil con tubo' },
  { key: 'XOA', value: 'Pallet, Según la clasificación de la compañía (Commonwealth Handling Equipment Pool (CHEP) 40 cm x 60 cm' },
  { key: 'XOB', value: 'Pallet, Según la clasificación de la compañía (Commonwealth Handling Equipment Pool (CHEP) 80 cm x 120 cm' },
  { key: 'XOC', value: 'Pallet, Según la clasificación de la compañía (Commonwealth Handling Equipment Pool (CHEP) 100 cm x 120 cm' },
  { key: 'XOD', value: 'Pallet, AS 4068-1993' },
  { key: 'XOE', value: 'Pallet, ISO T11' },
  { key: 'XOF', value: 'Plataforma, peso o dimensión no especificada' },
  { key: 'XOK', value: 'Bloque' },
  { key: 'XOT', value: 'Octabin' },
  { key: 'XP2', value: 'Charola' },
  { key: 'XPA', value: 'Cajetilla' },
  { key: 'XPB', value: 'Pallet, Caja combinada y abierta con caja y pallet.' },
  { key: 'XPC', value: 'Paquete postal' },
  { key: 'XPD', value: 'Pallet modular con collares (80cms * 100cms)' },
  { key: 'XPE', value: 'Pallet modular con collares (80cms * 120cms)' },
  { key: 'XPF', value: 'Corral' },
  { key: 'XPG', value: 'Placa' },
  { key: 'XPH', value: 'Cantaro' },
  { key: 'XPI', value: 'Pleca' },
  { key: 'XPJ', value: 'Canastilla' },
  { key: 'XPK', value: 'Paquete' },
  { key: 'XPL', value: 'Balde' },
  { key: 'XPN', value: 'Tablón' },
  { key: 'XPO', value: 'Bolsa pequeña' },
  { key: 'XPR', value: 'Contenedor de plástico' },
  { key: 'XPT', value: 'Maceta' },
  { key: 'XPU', value: 'Cacerola' },
  { key: 'XPV', value: 'Tubos, con fleje/ agrupados/ armados' },
  { key: 'XPX', value: 'Pallet' },
  { key: 'XPY', value: 'Placas con fleje/ agrupados/ armados' },
  { key: 'XPZ', value: 'Tablones con fleje/ agrupados/ armados' },
  { key: 'XQA', value: 'Tambor de acero con cabeza no desmontable' },
  { key: 'XQB', value: 'Tambor de  acero con cabeza extraíble' },
  { key: 'XQC', value: 'Tambor de aluminio con cabeza no extraíble' },
  { key: 'XQD', value: 'Tambor de aluminio con cabeza extraíble' },
  { key: 'XQF', value: 'Tambor, plástico con cabeza no desmontable' },
  { key: 'XQG', value: 'Tambor, plástico, cabeza extraíble' },
  { key: 'XQH', value: 'Barril de madera con tapón' },
  { key: 'XQJ', value: 'Barril de madera con cabeza desprendible' },
  { key: 'XQK', value: 'Bidón de acero con cabeza no desmontable' },
  { key: 'XQL', value: 'Bidón de acero con cabeza desmontable' },
  { key: 'XQM', value: 'Bidón de plástico con cabeza no desmontable' },
  { key: 'XQN', value: 'Bidón de plástico con cabeza extraíble' },
  { key: 'XQP', value: 'Caja de madera natural estándar' },
  { key: 'XQQ', value: 'Caja de madera natural con muros a prueba de filtraciones' },
  { key: 'XQR', value: 'Caja de plástico expandida' },
  { key: 'XQS', value: 'Caja de plástico sólida' },
  { key: 'XRD', value: 'Rod' },
  { key: 'XRG', value: 'Anillo' },
  { key: 'XRJ', value: 'Estante, Perchero para ropa' },
  { key: 'XRK', value: 'Estante' },
  { key: 'XRL', value: 'Carrete' },
  { key: 'XRO', value: 'Rollo' },
  { key: 'XRT', value: 'Red Roja' },
  { key: 'XRZ', value: 'Varillas  con fleje/ agrupados/ armados' },
  { key: 'XSA', value: 'Saco' },
  { key: 'XSB', value: 'Losa' },
  { key: 'XSC', value: 'Cajón poco profundo' },
  { key: 'XSD', value: 'Huso' },
  { key: 'XSE', value: 'Baúl' },
  { key: 'XSH', value: 'Bolsa pequeña hermética' },
  { key: 'XSI', value: 'Patín' },
  { key: 'XSK', value: 'Carcasa esqueleto' },
  { key: 'XSL', value: 'Hoja de deslizamiento' },
  { key: 'XSM', value: 'Hoja de metal' },
  { key: 'XSO', value: 'Carrete pequeño' },
  { key: 'XSP', value: 'Hoja de empaque de plástico' },
  { key: 'XSS', value: 'Cajón de acero' },
  { key: 'XSU', value: 'Maleta' },
  { key: 'XSV', value: 'Sobre de acero' },
  { key: 'XSW', value: 'Envoltorio' },
  { key: 'XSY', value: 'Manga' },
  { key: 'XSZ', value: 'Hojas  con fleje/ agrupados/ armados' },
  { key: 'XT1', value: 'Tableta' },
  { key: 'XTB', value: 'Tina' },
  { key: 'XTC', value: 'Caja para té' },
  { key: 'XTD', value: 'Tubo plegable' },
  { key: 'XTG', value: 'Contenedor de tanque genérico' },
  { key: 'XTI', value: 'Tierce' },
  { key: 'XTK', value: 'Tanque rectangular' },
  { key: 'XTL', value: 'Tina con tapa' },
  { key: 'XTN', value: 'Hojalata' },
  { key: 'XTO', value: 'Tonel' },
  { key: 'XTR', value: 'Maletero' },
  { key: 'XTS', value: 'Estructura' },
  { key: 'XTT', value: 'Bolsa de mano' },
  { key: 'XTU', value: 'Tubo' },
  { key: 'XTV', value: 'Tubo con boquilla' },
  { key: 'XTW', value: 'Pallet tricapa' },
  { key: 'XTY', value: 'Tanque cilíndrico' },
  { key: 'XTZ', value: 'Tubos  con fleje/ agrupados/ armados' },
  { key: 'XUC', value: 'Sin empaque' },
  { key: 'XUN', value: 'Unidad' },
  { key: 'XVA', value: 'Tanque' },
  { key: 'XVG', value: 'Tanque de gas (a 1,031 mbar y 15° C)' },
  { key: 'XVI', value: 'Frasco pequeño' },
  { key: 'XVK', value: 'Paquete transportable' },
  { key: 'XVL', value: 'Contenedor para líquidos a granel' },
  { key: 'XVN', value: 'Vehículo' },
  { key: 'XVO', value: 'Contenedor para sólido de partículas grandes a granel ("nódulos")' },
  { key: 'XVP', value: 'Envasado al vacío' },
  { key: 'XVQ', value: 'Tanque para Gas licuado (a temperatura / presión anormal)' },
  { key: 'XVR', value: 'Contenedor para sólidos de partículas granulares a granel (Granos)' },
  { key: 'XVS', value: 'Contenedor de chatarra a granel' },
  { key: 'XVY', value: 'Contenedor para sólido de partículas finas a granel ("polvos")' },
  { key: 'XWA', value: 'Contenedor de granel intermedio' },
  { key: 'XWB', value: 'Botella de mimbre' },
  { key: 'XWC', value: 'Contenedor intermedio para gráneles y de acero' },
  { key: 'XWD', value: 'Contenedor intermedio para gráneles y de aluminio' },
  { key: 'XWF', value: 'Contenedor intermedio para gráneles y de metal' },
  { key: 'XWG', value: 'Contenedor intermedio para gráneles y de acero presurizado menor a 10 kpa' },
  { key: 'XWH', value: 'Contenedor intermedio para gráneles y de aluminio, presurizado menor a 10 kpa' },
  { key: 'XWJ', value: 'Contenedor intermedio para gráneles y de metal con una presión de 10 kpa' },
  { key: 'XWK', value: 'Contenedor intermedio para gráneles y de acero para líquido' },
  { key: 'XWL', value: 'Contenedor intermedio para gráneles y de aluminio para líquido' },
  { key: 'XWM', value: 'Contenedor intermedio para gráneles y de metal para líquido' },
  { key: 'XWN', value: 'Contenedor intermedio para gráneles con tejido plástico sin capa con revestimiento' },
  { key: 'XWP', value: 'Contenedor intermedio para gráneles con tejido plástico y recubierto' },
  { key: 'XWQ', value: 'Contenedor intermedio para gráneles con tejido plástico con revestimiento' },
  { key: 'XWR', value: 'Contenedor intermedio para gráneles con tejido plástico, revestido y con forro' },
  { key: 'XWS', value: 'Contenedor intermedio para gráneles con película de plástico' },
  { key: 'XWT', value: 'Contenedor intermedio para gráneles textil sin capa / forro' },
  { key: 'XWU', value: 'Contenedor intermedio para gráneles de madera natural con forro interior' },
  { key: 'XWV', value: 'Contenedor intermedio para gráneles textil recubierto' },
  { key: 'XWW', value: 'Contenedor intermedio para gráneles textil con revestimiento' },
  { key: 'XWX', value: 'Contenedor intermedio para gráneles textil recubierto y con forro' },
  { key: 'XWY', value: 'Contenedor intermedio para gráneles contrachapado con revestimiento interior' },
  { key: 'XWZ', value: 'Contenedor intermedio para gráneles de madera reconstituida con revestimiento interior' },
  { key: 'XXA', value: 'Bolsa de tejido plástico, sin abrigo interior ni forro' },
  { key: 'XXB', value: 'Bolsa de tejido plástico a prueba de filtraciones' },
  { key: 'XXC', value: 'Bolsa de tejido plástico resistente al agua' },
  { key: 'XXD', value: 'Bolsa con película de plástico' },
  { key: 'XXF', value: 'Bolsa textil sin capa ni forro interior' },
  { key: 'XXG', value: 'Bolsa textil a prueba de filtraciones' },
  { key: 'XXH', value: 'Bolsa textil resistente al agua' },
  { key: 'XXJ', value: 'Bolsa de papel multi-pared' },
  { key: 'XXK', value: 'Bolsa de papel multi-pared, resistente al agua' },
  { key: 'XYA', value: 'Empaque compuesto, recipiente de plástico en tambor de acero' },
  { key: 'XYB', value: 'Empaque compuesto, recipiente de plástico en cajas de acero' },
  { key: 'XYC', value: 'Empaque compuesto, recipiente de plástico en tambor de aluminio' },
  { key: 'XYD', value: 'Empaque compuesto, recipiente de plástico en cajón de aluminio' },
  { key: 'XYF', value: 'Empaque compuesto, recipiente de plástico en caja de madera' },
  { key: 'XYG', value: 'Empaque compuesto, recipiente de plástico en tambor de madera contrachapada' },
  { key: 'XYH', value: 'Empaque compuesto, recipiente de plástico en caja de madera contrachapada' },
  { key: 'XYJ', value: 'Empaque compuesto, recipiente de plástico en tambor de fibra' },
  { key: 'XYK', value: 'Empaque compuesto, recipiente de plástico en caja de cartón' },
  { key: 'XYL', value: 'Empaque compuesto, recipiente de plástico en el tambor de plástico' },
  { key: 'XYM', value: 'Empaque compuesto, recipiente de plástico en caja de plástico sólido' },
  { key: 'XYN', value: 'Empaque compuesto, receptáculo de vidrio en tambor de acero' },
  { key: 'XYP', value: 'Empaque compuesto, receptáculo de vidrio en caja de cajas de acero' },
  { key: 'XYQ', value: 'Empaque compuesto, recipiente de vidrio en tambor de aluminio' },
  { key: 'XYR', value: 'Empaque compuesto, receptáculo de vidrio en caja de aluminio' },
  { key: 'XYS', value: 'Empaque compuesto, recipiente de vidrio en caja de madera' },
  { key: 'XYT', value: 'Empaque compuesto, recipiente de vidrio en tambor de madera contrachapada' },
  { key: 'Xyv', value: 'Empaque compuesto, recipiente de vidrio en el cesto de mimbre' },
  { key: 'XYW', value: 'Empaque compuesto, recipiente de vidrio en tambor de fibra' },
  { key: 'XYX', value: 'Empaque compuesto, recipiente de vidrio en caja de cartón' },
  { key: 'XYY', value: 'Empaque compuesto, recipiente de vidrio en paquete de plástico expandible' },
  { key: 'XYZ', value: 'Empaque compuesto, recipiente de vidrio en paquete de plástico sólido' },
  { key: 'XZA', value: 'Contenedor de granel intermedio, papel, multi-pared' },
  { key: 'XZB', value: 'Bolsa grande' },
  { key: 'XZC', value: 'Contenedor intermedio para gráneles de papel, multi-pared y resistente al agua' },
  { key: 'XZD', value: 'Contenedor intermedio para gráneles de plástico rígido, con equipo estructural para sólidos' },
  { key: 'XZF', value: 'Contenedor intermedio para gráneles de plástico rígido, autoportante para sólidos' },
  { key: 'XZG', value: 'Contenedor intermedio para gráneles de plástico rígido, con equipo estructural, presurizado' },
  { key: 'XZH', value: 'Contenedor intermedio para gráneles de plástico rígido, autoportante y presurizado' },
  { key: 'XZJ', value: 'Contenedor intermedio para gráneles de plástico rígido, con equipo estructural para líquidos' },
  { key: 'XZK', value: 'Contenedor intermedio para gráneles de plástico rígido, autoportante, líquidos' },
  { key: 'XZL', value: 'Contenedor intermedio para gráneles, compuesto y de plástico rígido, sólidos' },
  { key: 'XZM', value: 'Contenedor intermedio para gráneles, compuesto y de plástico flexible, sólidos' },
  { key: 'XZN', value: 'Contenedor intermedio para gráneles, compuesto y de plástico rígido, presurizado' },
  { key: 'XZP', value: 'Contenedor intermedio para gráneles, compuesto y de plástico flexible, presurizado' },
  { key: 'XZQ', value: 'Contenedor intermedio para gráneles, compuesto y de plástico rígido, líquidos' },
  { key: 'XZR', value: 'Contenedor intermedio para gráneles, compuesto y de plástico flexible para líquidos' },
  { key: 'XZS', value: 'Contenedor intermedio para gráneles, compuesto' },
  { key: 'XZT', value: 'Contenedor intermedio para gráneles con tablero de fibras' },
  { key: 'XZU', value: 'Contenedor intermedio para gráneles flexible' },
  { key: 'XZV', value: 'Contenedor intermedio para gráneles de metal, distinto del acero' },
  { key: 'XZW', value: 'Contenedor intermedio para gráneles, de madera natural' },
  { key: 'XZX', value: 'Contenedor intermedio para gráneles, de contrachapado' },
  { key: 'XZY', value: 'Contenedor intermedio para gráneles, de madera reconstituida' },
  { key: 'YDK', value: 'Yarda cuadrada' },
  { key: 'YDQ', value: 'Yarda cúbica' },
  { key: 'YL', value: 'Cien yardas lineales' },
  { key: 'YRD', value: 'Yarda' },
  { key: 'YT', value: 'Diez yardas' },
  { key: 'Z1', value: 'Furgoneta' },
  { key: 'Z11', value: 'Contenedor colgante ' },
  { key: 'Z5', value: 'Arrastre' },
  { key: 'Z6', value: 'Punto de conferencia' },
  { key: 'Z8', value: 'Página de noticias' },
  { key: 'ZP', value: 'Páginas' },
  { key: 'ZZ', value: 'Mutuamente definido' },
];

module.exports = keyUnit;
